
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea87e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea87e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("idIeD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lyxtH").then(()=>parcelRequire("cNEz7"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


function $ab86e7844b98ec72$export$2e2bcd8739ae039(tagName, options) {
    let elm;
    let opt = {};
    let index = 1;
    let hasParent = false;
    if (typeof options === "object" && !Array.isArray(options) && !(options instanceof Element)) {
        opt = options;
        index++;
    }
    if (tagName instanceof Element) elm = tagName;
    else {
        // allow tag.class and tag#id constructors
        if (tagName.indexOf(".") >= 0) {
            let classNames = tagName.split(".");
            tagName = classNames.shift();
            opt.className = ((opt.className || "") + " " + classNames.join(" ")).trim();
        }
        if (tagName.indexOf("#") >= 0) {
            let p = tagName.split("#");
            tagName = p.shift();
            opt.id = p[0];
        }
        tagName = tagName || "div";
        elm = document.createElement(tagName);
    }
    for(let key in opt){
        if (key === "parent") {
            opt[key].appendChild(elm);
            hasParent = true;
            continue;
        }
        if (key === "style" && typeof opt[key] === "object") {
            for(let styleKey in opt[key])elm.style[styleKey] = opt[key][styleKey];
            continue;
        }
        if (key === "onClick" || key === "onDoubleClick" || key === "onDrag" || key === "onDown") $ab86e7844b98ec72$var$addClass(elm, opt, "handle");
        if (key === "onDragStart") {
            $ab86e7844b98ec72$var$addClass(elm, opt, "draggable");
            if (opt.globalDrag) $ab86e7844b98ec72$var$addClass(elm, opt, "global");
        }
        if (key === "onDrop") $ab86e7844b98ec72$var$addClass(elm, opt, "droptarget");
        if (key === "onContext") $ab86e7844b98ec72$var$addClass(elm, opt, "context");
        if (key === "info") $ab86e7844b98ec72$var$addClass(elm, opt, "info");
        if (key === "key") {
            elm.setAttribute("data-i18", opt[key]);
            continue;
        }
        elm[key] = opt[key];
    }
    for(; index < arguments.length; index++)$ab86e7844b98ec72$var$append(elm, arguments[index]);
    return elm;
}
let $ab86e7844b98ec72$var$append = (parent, child)=>{
    if (child) {
        if (Array.isArray(child)) child.map((sub)=>$ab86e7844b98ec72$var$append(parent, sub));
        else {
            if (typeof child === "string" || typeof child === "number") child = document.createTextNode(child);
            parent.appendChild(child);
        }
    }
};
let $ab86e7844b98ec72$var$addClass = (elm, opt, className)=>{
    elm.classList.add(className);
    if (opt.className) opt.className += " " + className;
};


let $457b660dfd8a7276$var$Touch = ()=>{
    let me = {};
    let touchData = {};
    me.init = ()=>{
        document.body.addEventListener("pointerdown", handleTouchDown);
        document.body.addEventListener("pointermove", handleTouchMove);
        document.body.addEventListener("pointerup", handleTouchUp);
    };
    function handleTouchDown(event) {
        touchData.isDown = true;
        touchData.startX = event.clientX;
        touchData.startY = event.clientY;
        let clickTarget = event.target.closest(".handle");
        if (clickTarget && clickTarget.onClick) clickTarget.onClick(event, clickTarget);
        touchData.clickTarget = clickTarget;
        if (clickTarget && clickTarget.onDrag) {
            touchData.isDragging = true;
            touchData.startX = event.clientX;
            touchData.startY = event.clientY;
        }
    }
    function handleTouchMove(event) {
        if (touchData.isDragging) {
            touchData.deltaX = event.clientX - touchData.startX;
            touchData.deltaY = event.clientY - touchData.startY;
            touchData.clickTarget.onDrag(touchData);
        }
    }
    function handleTouchUp(event) {
        if (touchData.isDown) {
            if (touchData.clickTarget && touchData.clickTarget.onUp) touchData.clickTarget.onUp(event, touchData.clickTarget);
            touchData.isDragging = false;
        }
    }
    return me;
};
var $457b660dfd8a7276$export$2e2bcd8739ae039 = $457b660dfd8a7276$var$Touch();






let $0261694861269dc6$var$Chart = (()=>{
    let me = {};
    me.render = (container, config)=>{
        let chart, legend;
        let total = 0;
        config.items.forEach((item)=>{
            total += item.value;
        });
        config.items.forEach((item)=>{
            item.pct = Math.round(item.value / total * 100);
        });
        container.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".chart", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".front", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("b", total), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("small", config.title)), chart = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".piechart"), legend = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".legend")));
        var start = 0;
        var max = config.items.length - 1;
        config.items.forEach((piece, index)=>{
            var angle = piece.pct * 1.8;
            var end = start + angle;
            if (end > 180) end = 180;
            var revIndex = max - index;
            var p = generatePie(start, end, revIndex * 200, piece.color, piece.action);
            p.style.zIndex = index;
            p.id = "pie" + index;
            start = end;
            var item = generateLegentItem(piece.label, piece.color, index * 200, piece.value, piece.pct, piece.action);
            item.id = "legend" + index;
            item.onmouseover = function() {
                p.classList.add("active");
            };
            item.onmouseout = function() {
                p.classList.remove("active");
            };
            p.onmouseover = function() {
                item.classList.add("active");
            };
            p.onmouseout = function() {
                item.classList.remove("active");
            };
            chart.appendChild(p);
            legend.appendChild(item);
        });
    };
    function generatePie(start, end, delay, color, action) {
        var pie = document.createElement("div");
        pie.className = "pie";
        var lower = document.createElement("div");
        lower.className = "lower";
        lower.style.backgroundColor = color;
        if (action) lower.onclick = action;
        var upper = document.createElement("div");
        upper.className = "upper";
        setTimeout(()=>{
            upper.style.transform = "rotate(" + end + "deg)";
        }, 200 + delay);
        setTimeout(()=>{
            lower.style.transform = "rotate(" + start + "deg)";
        }, 250 + delay);
        pie.appendChild(lower);
        pie.appendChild(upper);
        return pie;
    }
    function rotatePie(elm, start, end, delay) {
        var lower = elm.querySelector(".lower");
        var upper = elm.querySelector(".upper");
        setTimeout(()=>{
            upper.style.transform = "rotate(" + end + "deg)";
        }, 250 + delay);
        setTimeout(()=>{
            lower.style.transform = "rotate(" + start + "deg)";
        }, 50 + delay);
    }
    function generateLegentItem(labelText, color, delay, value, pct, action) {
        var item = document.createElement("div");
        item.className = "item";
        if (action) item.onclick = action;
        var label = document.createElement("div");
        label.className = "label";
        label.innerHTML = '<span class="main">' + labelText + "</span>";
        label.innerHTML += '<span class="val">' + value + "</span>";
        if (pct) label.innerHTML += '<span class="pct">' + pct + "%</span>";
        var dot = document.createElement("div");
        dot.className = "dot";
        dot.style.backgroundColor = color;
        item.appendChild(dot);
        item.appendChild(label);
        setTimeout(()=>{
            item.classList.add("visible");
        }, 500 + delay);
        return item;
    }
    return me;
})();
var $0261694861269dc6$export$2e2bcd8739ae039 = $0261694861269dc6$var$Chart;




const $a326efb1bdfc44d1$var$Translations = {};
$a326efb1bdfc44d1$var$Translations.load = async (lang)=>{
    if (!lang) lang = localStorage.getItem("language") || "fr";
    localStorage.setItem("language", lang);
    console.log("Loading translations for " + lang);
    let path = "_data/translations/" + lang + ".json?v=" + Date.now();
    try {
        let response = await fetch(path);
        let json = await response.json();
        Object.assign($a326efb1bdfc44d1$var$Translations, json);
    } catch (e) {
        console.error("Error loading translations", e);
    }
};
var $a326efb1bdfc44d1$export$2e2bcd8739ae039 = $a326efb1bdfc44d1$var$Translations;


let $7cd192843b2495ee$var$Settings = (()=>{
    let me = {
        version: "0.0.20",
        skipLogin: false,
        autoTranslate: false,
        useIncidentComments: true,
        useIncidentActions: true,
        stripNumbersFromIncidentCaption: true
    };
    me.getTheme = ()=>{
        return localStorage.getItem("theme") || "dark";
    };
    me.setTheme = (theme)=>{
        localStorage.setItem("theme", theme);
    };
    me.getLanguage = ()=>{
        return localStorage.getItem("language") || "fr";
    };
    me.setLanguage = (language)=>{
        localStorage.setItem("language", language);
    };
    return me;
})();
var $7cd192843b2495ee$export$2e2bcd8739ae039 = $7cd192843b2495ee$var$Settings;


let $dad842a3fb977628$var$User = (()=>{
    let me = {};
    let currentUser = null;
    me.login = async (username, password)=>{
        let result = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).login(username, password);
        if (result && result.user) {
            currentUser = result.user;
            if (currentUser.token) localStorage.setItem("token", currentUser.token);
            return {
                success: true,
                needsPasswordReset: result.needsPasswordReset
            };
        }
        return {
            success: false
        };
    };
    me.logout = ()=>{
        localStorage.removeItem("token");
        window.location.hash = "";
        window.location.reload();
    };
    me.getCurrentUser = ()=>{
        return currentUser;
    };
    me.isLoggedIn = async ()=>{
        let queryParams = new URLSearchParams(window.location.search);
        let userToken = queryParams.get("token");
        if (currentUser && currentUser.id) return true;
        let token = localStorage.getItem("token");
        if (!token && !userToken) return false;
        let result = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).checkToken(token);
        if (result && result.user) {
            currentUser = result.user;
            (0, $7cd192843b2495ee$export$2e2bcd8739ae039).setLanguage(currentUser.language);
            (0, $7cd192843b2495ee$export$2e2bcd8739ae039).setTheme(currentUser.theme || "dark");
            if (currentUser.theme === "light") document.body.classList.add("light");
            return true;
        } else {
            localStorage.removeItem("token");
            return false;
        }
    };
    me.getUserId = ()=>{
        return currentUser && currentUser.id || "";
    };
    me.getUserOrganisation = ()=>{
        return currentUser && currentUser.organisation || "";
    };
    me.getAccesToken = ()=>{
        return currentUser && currentUser.token || 0;
    };
    me.getSessionId = ()=>{
        return currentUser && currentUser.sessionId || 0;
    };
    me.isAdmin = ()=>{
        return currentUser && (currentUser.role === "admin" || currentUser.role === "owner");
    };
    me.isOwner = ()=>{
        return currentUser && currentUser.role === "owner";
    };
    me.renderUserMenu = (container)=>{
        let menu;
        let lanbox, themebox, emailbox;
        let lan = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        let theme = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getTheme();
        container.appendChild(menu = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".usermenu", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".username", {
            onClick: ()=>{
                menu.classList.toggle("active");
            }
        }, currentUser.fullname), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menu", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menuitem", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).language), lanbox = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".yesno", {
            onClick: async ()=>{
                lanbox.classList.toggle("active");
                lan = lanbox.classList.contains("active") ? "en" : "fr";
                await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("users", {
                    id: currentUser.id,
                    language: lan
                });
                (0, $7cd192843b2495ee$export$2e2bcd8739ae039).setLanguage(lan);
                setTimeout(()=>window.location.reload(), 200);
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", "FR"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", "EN"))), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menuitem", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).theme), themebox = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".yesno", {
            onClick: async ()=>{
                themebox.classList.toggle("active");
                theme = themebox.classList.contains("active") ? "dark" : "light";
                await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("users", {
                    id: currentUser.id,
                    theme: theme
                });
                (0, $7cd192843b2495ee$export$2e2bcd8739ae039).setTheme(theme);
                document.body.classList.toggle("light", theme === "light");
            //console.error("Theme",theme);
            //setTimeout(()=>window.location.reload(),200);
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).light), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).dark))), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menuitem", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).emailnotificationsShort), emailbox = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".yesno", {
            onClick: async ()=>{
                emailbox.classList.toggle("active");
                let value = !emailbox.classList.contains("active");
                await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("users", {
                    id: currentUser.id,
                    emailnotifications: value
                });
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no))), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menuitem", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red", {
            onClick: me.logout
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).logout)))));
        if (lan === "en") lanbox.classList.add("active");
        if (theme === "dark") themebox.classList.add("active");
        if (!currentUser.emailnotifications) emailbox.classList.add("active");
    };
    return me;
})();
var $dad842a3fb977628$export$2e2bcd8739ae039 = $dad842a3fb977628$var$User;


var $9a3384fd4b0dd5ab$var$EventBus = function() {
    var allEventHandlers = {};
    var me = {};
    me.on = function(event, listener) {
        var eventHandlers = allEventHandlers[event];
        if (!eventHandlers) {
            eventHandlers = [];
            allEventHandlers[event] = eventHandlers;
        }
        eventHandlers.push(listener);
    };
    me.trigger = function(event, context) {
        var eventHandlers = allEventHandlers[event];
        if (eventHandlers) {
            var i, len = eventHandlers.length;
            for(i = 0; i < len; i++)eventHandlers[i](context, event);
        }
    };
    return me;
};
var $9a3384fd4b0dd5ab$export$2e2bcd8739ae039 = $9a3384fd4b0dd5ab$var$EventBus();



function $4ef65c8b9751a142$export$3ae94a2503e890a1(date) {
    let sDate = date;
    if (!date) return "";
    if (typeof date === "string") {
        let parts = sDate.split("/");
        if (parts.length === 3) {
            if (parts[2].length === 4) date = parts[2] + "/" + parts[1] + "/" + parts[0];
        }
        date = new Date(date);
    }
    if (typeof date === "number") date = new Date(date);
    let month = date.getMonth() + 1;
    if (isNaN(month)) {
        if (sDate.indexOf("/") > 0) {
            let parts = sDate.split("/");
            if (parts.length === 3) {
                date = new Date(parts[2] + "/" + parts[1] + "/" + parts[0]);
                month = date.getMonth() + 1;
            }
        }
    }
    if (isNaN(month)) {
        console.error("invalid date", sDate);
        //return sDate;
        return "";
    }
    let day = date.getDate();
    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;
    let formatted = date.getFullYear() + "/" + month + "/" + day;
    return formatted;
}
function $4ef65c8b9751a142$export$f35be9d42a770276(date) {
    date = date || "";
    return date.replaceAll("/", "-");
}
function $4ef65c8b9751a142$export$cb0bbc88c7f09596(str) {
    if (str) return str.trim().replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
    return "";
}
function $4ef65c8b9751a142$export$a1a1baf9c6597488(str) {
    if (typeof str !== "string") return false;
    return !!str.match(/^[a-f0-9]{8}(-[a-f0-9]{4}){4}[a-f0-9]{8}$/i);
}






let $150917cc518d921d$var$TranslationService = (()=>{
    let me = {};
    let cacheMap = {};
    let reversed = {};
    let useTranslationService = false;
    me.translate = async (key, fromLan, toLan)=>{
        if ((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[key]) return (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[key];
        let cache = cacheMap[fromLan + "_" + toLan];
        if (!cache) {
            cache = {};
            cacheMap[fromLan + "_" + toLan] = cache;
        }
        if (cache[key]) {
            console.log("Returning from cache");
            return cache[key];
        }
        if (useTranslationService) {
            let result = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).translate(key, fromLan, toLan);
            cache[key] = result;
            return result;
        } else return key;
    };
    me.box = (text, src, target)=>{
        if (!useTranslationService) return text;
        let elm;
        let button;
        if (src === target) return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".text", text);
        let isTranslated = false;
        return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".translatebox", elm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".text", text), button = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".button", {
            onClick: ()=>{
                if (isTranslated) {
                    elm.innerHTML = "";
                    elm.innerText = text;
                    isTranslated = false;
                } else {
                    elm.innerHTML = "";
                    elm.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                    me.translate(text, src, target).then((result)=>{
                        if (result.result) {
                            elm.innerHTML = "";
                            elm.innerText = result.result;
                        } else elm.innerText = result;
                        isTranslated = true;
                        button.innerText = "Show original";
                    });
                }
            }
        }, "Translate to " + target.toUpperCase()));
    };
    me.map = (value)=>{
        let result = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(value)];
        if (result) {
            reversed[result] = value;
            return result;
        }
        if (value.indexOf("(") > 0) {
            let parts = value.split("(");
            let key = (0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(parts[0].trim());
            let val = parts[1].trim();
            if (val.endsWith(")")) val = val.substring(0, val.length - 1).trim();
            result = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[key] || key;
            let tVal = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(val)] || val;
            result = result + " (" + tVal + ")";
            reversed[result] = value;
            return result;
        }
        return value;
    };
    me.reverse = (value)=>{
        if (reversed[value]) return reversed[value];
        for(let key in 0, $a326efb1bdfc44d1$export$2e2bcd8739ae039){
            if ((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[key] === value) return key;
        }
        return value;
    };
    return me;
})();
var $150917cc518d921d$export$2e2bcd8739ae039 = $150917cc518d921d$var$TranslationService;


let $1405dab32d7e0174$var$Api = (()=>{
    let me = {};
    //let apiUrl = "http://localhost:8080/api/";
    //if (window.location.hostname.indexOf("kufatilia")>=0) apiUrl = "/api/";
    let apiUrl = "/api/";
    //if (window.location.hostname.indexOf("localhost")>=0) apiUrl = "http://localhost:8080/api/";
    if (window.location.pathname.indexOf("/test/") >= 0) apiUrl = "/dev/";
    let dataCache = {
        distinct: {},
        dump: {},
        resolved: {}
    };
    me.list = async (profile, filter)=>{
        if (dataCache[profile]) return filterList(dataCache[profile], filter);
        let url = apiUrl + profile;
        let json = await getJson(url);
        dataCache[profile] = json;
        return filterList(json, filter);
    };
    me.dump = async (profile, filter)=>{
        let url = apiUrl + profile + "?dump=true&filter=" + filter;
        return getJson(url);
    };
    me.get = async (profile)=>{
        let url = apiUrl + profile;
        return getJson(url);
    };
    me.distinct = async (profile, field, filterName)=>{
        let key = profile + "_" + field;
        if (filterName) key += "_" + filterName;
        let url = apiUrl + profile + "?distinct=" + field + "&filter=" + filterName;
        let orgId;
        if (filterName === "complete" || filterName === "new") {
            orgId = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserOrganisation();
            url += "&org=" + orgId;
            key += "_" + orgId;
        }
        if (dataCache.distinct[key]) return dataCache.distinct[key];
        let json = await getJson(url);
        dataCache.distinct[key] = json;
        return json;
    };
    me.getById = async (profile, id, forceRefresh)=>{
        if (!forceRefresh) {
            if (dataCache[profile + "_" + id]) return dataCache[profile + "_" + id];
            if (dataCache[profile]) return dataCache[profile].find((item)=>item.id === id);
        }
        let url = apiUrl + profile + "/" + id;
        let json = await getJson(url);
        dataCache[profile + "_" + id] = json;
        return json;
    };
    me.resolve = (profile, id)=>{
        if (dataCache[profile + "_" + id]) return dataCache[profile + "_" + id];
        if (dataCache[profile]) return dataCache[profile].find((item)=>item.id === id);
    };
    me.resolveAll = (config, data)=>{
        return new Promise(async (next)=>{
            if (dataCache.resolved[config.profile] && !data) {
                next();
                return;
            }
            let useCache = false;
            if (!data) {
                data = await me.list(config.profile);
                useCache = true;
            }
            if (data && data.length) {
                data.forEach((item)=>{
                    config.fields.forEach((field)=>{
                        if (!field.isPrimary) return;
                        let value = "" + (item[field.key] || "");
                        if (!value && field.keyAlt) value = "" + (item[field.keyAlt] || "");
                        if (field.type === "fk") {
                            let profile = field.target.split(".")[0];
                            let fieldName = field.target.split(".")[1] || "id";
                            let itemData;
                            if (dataCache[profile + "_" + value]) itemData = dataCache[profile + "_" + value];
                            if (dataCache[profile]) itemData = dataCache[profile].find((item)=>item.id === value);
                            if (itemData) item[field.key + "_resolved"] = itemData[fieldName];
                        }
                        if (field.type === "boolean") {
                            value = value === "true" ? (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes : (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no;
                            item[field.key + "_resolved"] = value;
                        }
                        if (field.translate) {
                            value = (0, $150917cc518d921d$export$2e2bcd8739ae039).map(value);
                            item[field.key + "_resolved"] = value;
                        }
                        if (field.format === "date") {
                            value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
                            item[field.key + "_resolved"] = value;
                        }
                    });
                });
                if (useCache) dataCache.resolved[config.profile] = true;
            }
            next();
        });
    };
    me.getIncident = async (id)=>{
        let profile = "incidents_external";
        // Note: this is not entirely accurate anymore as for Twilio we use UUIDs too ...
        // For now, we handle this in the backend.
        if (isNaN(id)) profile = "incidents";
        let url = apiUrl + profile + "/" + id;
        let json = await getJson(url);
        return json || {};
    };
    me.update = async (profile, obj)=>{
        let url = apiUrl + profile;
        let response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(obj),
            headers: {
                Authorization: "Bearer " + (0, $dad842a3fb977628$export$2e2bcd8739ae039).getSessionId()
            }
        });
        let json = await response.json();
        dataCache[profile + "_" + json.id] = json;
        if (dataCache[profile]) {
            let existing = dataCache[profile].find((item)=>item.id === json.id);
            if (existing) Object.assign(existing, json);
            else dataCache[profile].push(json);
        }
        //console.error(profile,json);
        if (profile === "incidents_info" && json.incident) {
            let dto = Object.assign({}, json);
            delete dto.id;
            // update original incident
            let baseProfile = dataCache["incidents_external"];
            if (baseProfile) {
                let existing = baseProfile.find((item)=>item.report_id == dto.incident);
                if (existing) Object.assign(existing, dto);
            }
            // update assigned incident
            baseProfile = dataCache["incidents_assigned"];
            if (baseProfile) {
                let existing = baseProfile.find((item)=>item.incident == dto.incident);
                if (existing) Object.assign(existing, dto);
            }
        }
        (0, $9a3384fd4b0dd5ab$export$2e2bcd8739ae039).trigger("dataChanged", profile);
        return json;
    };
    me.updateCache = (profile, obj)=>{
        dataCache[profile + "_" + obj.id] = obj;
        if (dataCache[profile]) {
            let existing = dataCache[profile].find((item)=>item.id === obj.id);
            if (existing) Object.assign(existing, obj);
            else dataCache[profile].push(obj);
        }
    };
    me.clearCache = (profile)=>{
        dataCache[profile] = undefined;
    };
    me.countCache = (profile, filter)=>{
        if (dataCache[profile]) return filterList(dataCache[profile], filter).length;
        return 0;
    };
    me.delete = async (profile, id)=>{
        //incidents_assigned
        let url = apiUrl + profile + "/" + id;
        let response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + (0, $dad842a3fb977628$export$2e2bcd8739ae039).getSessionId()
            }
        });
        let json = await response.json();
        dataCache[profile + "_" + id] = undefined;
        if (dataCache[profile]) dataCache[profile] = dataCache[profile].filter((item)=>item.id !== id);
        if (profile === "incidents") {
            let linkedProfiles = [
                "incidents_external",
                "incidents_assigned"
            ];
            linkedProfiles.forEach((linkedProfile)=>{
                if (dataCache[linkedProfile]) {
                    dataCache[linkedProfile] = dataCache[linkedProfile].filter((item)=>item.incident !== id);
                    dataCache[linkedProfile] = dataCache[linkedProfile].filter((item)=>item.id !== id);
                    dataCache[linkedProfile] = dataCache[linkedProfile].filter((item)=>item.report_id !== id);
                }
                dataCache[linkedProfile + "_" + id] = undefined;
            });
        }
        return json;
    };
    me.getStats = async (orgId, forceRefresh)=>{
        let url = apiUrl + "stats?org=" + orgId;
        let json = {};
        if (forceRefresh) json = await getJson(url);
        else {
            if (dataCache["incidents_external"]) json = {
                incidents: me.countCache("incidents_external"),
                archived: me.countCache("incidents_external", {
                    archived: true
                }),
                assigned: me.countCache("incidents_external", {
                    assigned: (item)=>!!item.assigned && !item.archived
                })
            };
            if (dataCache["incidents_assigned"]) json = Object.assign(json, {
                closed: me.countCache("incidents_assigned", {
                    closed: true
                }),
                open: me.countCache("incidents_assigned", {
                    open: (item)=>item.accepted && !item.closed
                }),
                working: me.countCache("incidents_assigned", {
                    working: (item)=>item.accepted && item.assigned === orgId && !item.closed
                }),
                complete: me.countCache("incidents_assigned", {
                    complete: (item)=>item.accepted && item.assigned === orgId && item.closed
                }),
                new: me.countCache("incidents_assigned", {
                    assigned: (item)=>!item.accepted && item.assigned === orgId
                })
            });
        }
        if (json && json.incidents) json.nonassigned = json.incidents - (json.assigned || 0) - (json.archived || 0);
        return json;
    };
    me.getLogs = async ()=>{
        let url = apiUrl + "logs";
        let json = await getJson(url);
        return json;
    };
    me.login = async (username, password)=>{
        let url = apiUrl + "login";
        let response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                username: username,
                password: password
            })
        });
        let json = await response.json();
        return json;
    };
    me.resetPassword = async (email)=>{
        let url = apiUrl + "resetpass";
        let response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                email: email
            })
        });
        let json = await response.json();
        return json;
    };
    me.checkToken = async (token)=>{
        let url = apiUrl + "token";
        let response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                token: token
            })
        });
        let json = await response.json();
        return json;
    };
    me.changePassword = async (password)=>{
        let url = apiUrl + "pass";
        let response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                userId: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
                password: password
            })
        });
        let json = await response.json();
        return json;
    };
    me.isDev = ()=>{
        return apiUrl.indexOf("/dev/") >= 0;
    };
    function filterList(list, filter) {
        if (!filter) return list;
        console.log("Filtering");
        return list.filter((item)=>{
            let pass = true;
            for(let key in filter){
                if (typeof filter[key] === "function") {
                    if (!filter[key](item)) pass = false;
                } else if (item[key] != filter[key]) pass = false;
            }
            return pass;
        });
    }
    function getJson(url) {
        return new Promise((next)=>{
            fetch(url, {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + (0, $dad842a3fb977628$export$2e2bcd8739ae039).getSessionId()
                }
            }).then((response)=>{
                response.json().then(next);
            });
        });
    }
    me.sendNotification = async (type, recipient, data)=>{
        let url = apiUrl + "notification";
        let response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                type: type,
                recipient: recipient,
                data: data
            }),
            headers: {
                Authorization: "Bearer " + (0, $dad842a3fb977628$export$2e2bcd8739ae039).getSessionId()
            }
        });
        let json = await response.json();
        return json;
    };
    return me;
})();
var $1405dab32d7e0174$export$2e2bcd8739ae039 = $1405dab32d7e0174$var$Api;






let $0a8366f18a86398d$var$Home = (()=>{
    let me = {};
    me.render = async (container)=>{
        container.innerHTML += "";
        let chartContainer, logContainer;
        container.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".home", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".dashboard", chartContainer = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".chartContainer"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".logContainer", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".title", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).recentActivities), logContainer = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".logs"))), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".logo")));
        let userData = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getCurrentUser();
        let orgId = userData ? userData.organisation : "";
        let stats = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getStats(orgId, true);
        console.log(stats);
        if ((0, $dad842a3fb977628$export$2e2bcd8739ae039).isAdmin()) {
            let rawChart = {
                title: "Incidents SMS",
                items: [
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).nonAssigned,
                        value: stats.nonassigned,
                        color: "#b78938",
                        action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-sms/non-assignes")
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigned,
                        value: stats.assigned,
                        color: "#8cce71",
                        action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-sms/assignes")
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived,
                        value: stats.archived,
                        color: "#51869d",
                        action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-sms/archives")
                    }
                ]
            };
            (0, $0261694861269dc6$export$2e2bcd8739ae039).render(chartContainer, rawChart);
        }
        let mycsoChart = {
            title: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).myIncidents,
            items: [
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).new,
                    value: stats.new,
                    color: "#b78938",
                    action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("mes-incidents/nouveaux")
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).active,
                    value: stats.working,
                    color: "#8cce71",
                    action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("mes-incidents/ouvert")
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).completed,
                    value: stats.complete,
                    color: "#51869d",
                    action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("mes-incidents/completes")
                }
            ]
        };
        (0, $0261694861269dc6$export$2e2bcd8739ae039).render(chartContainer, mycsoChart);
        let csoChart = {
            title: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).allIncidents + " CSO",
            items: [
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).new,
                    value: stats.pending,
                    color: "#b78938",
                    action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-cso/nouveaux")
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).open,
                    value: stats.open,
                    color: "#5887af",
                    action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-cso/ouvert")
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).completed,
                    value: stats.closed,
                    color: "#8cce71",
                    action: ()=>(0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-cso/completes")
                }
            ]
        };
        (0, $0261694861269dc6$export$2e2bcd8739ae039).render(chartContainer, csoChart);
        let actionMap = {
            "create": "created",
            "update": "updated",
            "delete": "deleted",
            "login": "logged in",
            "logout": "logged out",
            "assign": "assigned",
            "unassign": "unassigned",
            "accept": "accepted",
            "unaccept": "unaccepted",
            "resolve": "resolved",
            "unresolve": "unresolved",
            "archive": "archived",
            "unarchive": "unarchived",
            "close": "closed",
            "reopen": "reopened",
            "comment": "commented",
            "password": "changed password"
        };
        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getLogs().then(async (logs)=>{
            let users = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("users");
            let organisations = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("organisations");
            console.log(logs);
            logs.forEach((log)=>{
                let userName = "";
                if (log.user) {
                    let user = (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolve("users", log.user);
                    if (user) userName = user.username;
                }
                let action = actionMap[log.type] || log.type;
                action = userName + " " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[action];
                if (log.incident) {
                    let displayId = log.incident;
                    if (typeof displayId === "string" && displayId.indexOf("-") > 0) displayId = displayId.split("-")[0];
                    action += " incident " + displayId;
                }
                if (log.organisation) {
                    let organisation = (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolve("organisations", log.organisation);
                    if (organisation) action += " " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).to + " " + organisation.name;
                }
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".logitem", {
                    parent: logContainer,
                    onClick: ()=>{
                        if (log.incident) (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("incidents-cso/" + log.incident);
                    }
                }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".logdate", (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(log.lastModified)), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".logtext", action));
            });
        });
    };
    return me;
})();
var $0a8366f18a86398d$export$2e2bcd8739ae039 = $0a8366f18a86398d$var$Home;










let $27ed2bfcca54492f$var$Data = (()=>{
    let me = {};
    me.init = ()=>{
        let actionTypes = [
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).incident_verification,
                value: "verification"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actiontype_referral,
                value: "referral"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actiontype_information,
                value: "information"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actiontype_dialogue,
                value: "dialogue"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actiontype_awareness,
                value: "awareness"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actiontype_advocacy,
                value: "advocacy"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).other,
                value: "other"
            }
        ];
        let actionModes = [
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mode_phone,
                value: "phone"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mode_email,
                value: "email"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mode_letter,
                value: "letter"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mode_person,
                value: "person"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mode_group,
                value: "group"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).other,
                value: "other"
            }
        ];
        let actionActors = [
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).anr,
                value: "anr"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).govt_local,
                value: "govt_local"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).govt_regional,
                value: "govt_regional"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).govt_national,
                value: "govt_national"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).crcc,
                value: "crcc"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actor_company,
                value: "company"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actor_cooperation,
                value: "cooperation"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).dgm,
                value: "dgm"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fardc,
                value: "fardc"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fec,
                value: "fec"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).armed_group,
                value: "armed_group"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cso,
                value: "cso"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).monitorfp,
                value: "monitorfp"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).police_pnc,
                value: "police_pnc"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).state_service,
                value: "state_service"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).private_security,
                value: "private_security"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cls_cps,
                value: "cls_cps"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actor_witness,
                value: "witness"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).victim,
                value: "victim"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).other,
                value: "other"
            }
        ];
        let regions = {
            "Haut-Uele": [
                "Dungu",
                "Faradje",
                "Niangara",
                "Rungu",
                "Wamba",
                "Watsa"
            ],
            "Ituri": [
                "Aru",
                "Djugu",
                "Irumu",
                "Mahagi",
                "Mambasa"
            ],
            "Lualaba": [
                "Dilolo",
                "Kapanga",
                "Lubudi",
                "Mutshatsha",
                "Sandoa",
                "Ville de Kolwezi"
            ],
            "Maniema": [
                "Kabambare",
                "Kailo",
                "Kasongo",
                "Kibombo",
                "Kindu",
                "Lubutu",
                "Pangi",
                "Punia"
            ],
            "Nord-Kivu": [
                "Beni",
                "Lubero",
                "Masisi",
                "Nyiragongo",
                "Rutshuru",
                "Walikale"
            ],
            "Sud-Kivu": [
                "Fizi",
                "Idjwi",
                "Kabare",
                "Kalehe",
                "Mwenga",
                "Shabunda",
                "Uvira",
                "Walungu"
            ],
            "Tanganyika": [
                "Kabalo",
                "Kalemie",
                "Kongolo",
                "Manono",
                "Moba",
                "Nyunzu"
            ],
            "Autre province": [
                "Autre territoire"
            ]
        };
        let categories = {
            "Accident": [
                "Traffic accident",
                "Asphyxia",
                "Equipment failure",
                "Landslide",
                "Pit collapse",
                "Flooding",
                "Use of explosives",
                "Other"
            ],
            "Roadblock": [
                "Abuse of power",
                "Arbitrary arrest",
                "Bribery",
                "Illegal taxation",
                "Violence",
                "Other"
            ],
            industrial_conflict: [
                "Destruction of rivers",
                "Mining concession invasion",
                "Relocation standards",
                "Other"
            ],
            "Corruption/Fraud": [
                "Mixing origin of minerals",
                "Non-declaration of production",
                "Bribery",
                "Illegal taxation",
                "Selling of iTSCi tags",
                "Other"
            ],
            "Environmental issue": [
                "Poaching",
                "Deforestation",
                "Destruction of rivers",
                "Unfilled holes",
                "Pollution",
                "Use of toxic products",
                "Other"
            ],
            "Child labor": [
                "Crushing or panning",
                "Surface digging",
                "Underground digging",
                "Operating machines",
                "Mineral collection",
                "Transporting",
                "Use of toxic products",
                "Other",
                "None"
            ],
            "Violence": [
                "Armed attack",
                "Fight or quarrel",
                "Vigilantism",
                "Kidnapping",
                "Murder",
                "Torture",
                "Forced labour",
                "Sexual violence",
                "Other"
            ],
            "Theft": [
                "Extorsion",
                "Looting",
                "Armed robbery",
                "Simple Theft",
                "Other"
            ],
            "Other": [
                "Other"
            ]
        };
        let childrenCategories = [
            "Small commerce",
            "Prostitution",
            "Transporting products",
            "Other",
            "None"
        ];
        let responsibleActors = [
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).unknown,
                value: "unknown"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).anr,
                value: "anr"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actor_company,
                value: "company"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actor_cooperation,
                value: "cooperation"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).dgm,
                value: "dgm"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fardc,
                value: "fardc"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).armed_group,
                value: "armed_group"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).community,
                value: "community"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).miners_transporters,
                value: "miners"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).police_pnc,
                value: "police_pnc"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).state_service,
                value: "state_service"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).private_security,
                value: "private_security"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).other,
                value: "other"
            }
        ];
        let territoireLocations = {
            Rungu: {
                latitude: 2.668,
                longitude: 27.6489255408781
            },
            Niangara: {
                latitude: 3.512,
                longitude: 27.9016848247627
            },
            Dungu: {
                latitude: 4.072,
                longitude: 28.4185767921046
            },
            Wamba: {
                latitude: 2.104,
                longitude: 27.83610526906
            },
            Faradje: {
                latitude: 3.54,
                longitude: 29.9776464583297
            },
            Watsa: {
                latitude: 2.737,
                longitude: 29.2605691085919
            },
            Djugu: {
                latitude: 1.944,
                longitude: 30.3243837352359
            },
            Mahagi: {
                latitude: 2.354,
                longitude: 30.7133206376299
            },
            Aru: {
                latitude: 3.067,
                longitude: 30.5332204968841
            },
            Irumu: {
                latitude: 1.228,
                longitude: 29.9002899111641
            },
            Mambasa: {
                latitude: 1.494,
                longitude: 28.7779410904815
            },
            Mutshatsha: {
                latitude: -10.77,
                longitude: 25.0570728905394
            },
            Lubudi: {
                latitude: -10.225,
                longitude: 26.1370602169313
            },
            "Ville de Kolwezi": {
                latitude: -10.71484,
                longitude: 25.4667
            },
            Kapanga: {
                latitude: -8.4667,
                longitude: 22.4
            },
            Dilolo: {
                latitude: -10.6667,
                longitude: 22.3333
            },
            Sandoa: {
                latitude: -8.95,
                longitude: 23.95
            },
            Kindu: {
                latitude: -2.97,
                longitude: 25.9124992832093
            },
            Lubutu: {
                latitude: -0.778,
                longitude: 26.8099739403865
            },
            Punia: {
                latitude: -1.712,
                longitude: 26.7807144670867
            },
            Kabambare: {
                latitude: -4.541,
                longitude: 27.721021737493
            },
            Kasongo: {
                latitude: -4.361,
                longitude: 26.4623205320502
            },
            Kailo: {
                latitude: -2.507,
                longitude: 25.6815707364452
            },
            Pangi: {
                latitude: -3.188,
                longitude: 26.5655252235655
            },
            Kibombo: {
                latitude: -4.075,
                longitude: 25.4277204822976
            },
            Walikale: {
                latitude: -1.105,
                longitude: 28.1661663936745
            },
            Masisi: {
                latitude: -1.41,
                longitude: 28.8490522552961
            },
            Rutshuru: {
                latitude: -1.031,
                longitude: 29.3458253465677
            },
            Beni: {
                latitude: 0.475,
                longitude: 29.4554831118829
            },
            Lubero: {
                latitude: 0.036,
                longitude: 28.7485144421101
            },
            Nyiragongo: {
                latitude: -1.542,
                longitude: 29.2752332850615
            },
            Idjwi: {
                latitude: -2.121,
                longitude: 29.0617094461649
            },
            Mwenga: {
                latitude: -3.329,
                longitude: 28.369724436641
            },
            Shabunda: {
                latitude: -2.911,
                longitude: 27.5788296464442
            },
            Fizi: {
                latitude: -4.24,
                longitude: 28.7160641247728
            },
            Kalehe: {
                latitude: -2.074,
                longitude: 28.5993645772594
            },
            Walungu: {
                latitude: -2.712,
                longitude: 28.6429882785182
            },
            Uvira: {
                latitude: -3.201,
                longitude: 29.0058420033867
            },
            Kabare: {
                latitude: -2.424,
                longitude: 28.6403535824063
            },
            Kongolo: {
                latitude: -5.366,
                longitude: 26.851731601852
            },
            Nyunzu: {
                latitude: -5.727,
                longitude: 27.9358543607606
            },
            Kalemie: {
                latitude: -6.007,
                longitude: 28.8233045311648
            },
            Kabalo: {
                latitude: -6.256,
                longitude: 26.8903232123947
            },
            Moba: {
                latitude: -7.562,
                longitude: 29.5491493249578
            },
            Manono: {
                latitude: -7.214,
                longitude: 27.5709788679189
            }
        };
        me.incidentsSMS = {
            profile: "incidents_external",
            fields: [
                /*{label: "id", key: "id", type: "text", isPrimary: true, size: 40}, */ {
                    label: "report_id",
                    key: "report_id",
                    type: "hidden",
                    isPrimary: true
                },
                //{label: "coordinates", key: "coordinates", type: "map"},
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).date,
                    key: "report_date",
                    type: "date",
                    isPrimary: true,
                    format: "date"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).status,
                    key: "platform_status",
                    type: "text",
                    isPrimary: true,
                    enumFilter: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).localisation,
                    key: "platform_location",
                    type: "text",
                    isPrimary: true,
                    size: 250
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).category,
                    key: "platform_category",
                    type: "text",
                    isPrimary: true,
                    enumFilter: true,
                    translate: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigned,
                    key: "assigned",
                    type: "fk",
                    target: "organisations.name",
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived,
                    key: "archived",
                    type: "boolean"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).feedback,
                    key: "feedback",
                    type: "textarea"
                }
            ],
            export: true
        };
        me.incidentsGenericInfo = [
            {
                type: "caption",
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).incident
            },
            {
                key: "report_date"
            },
            {
                key: "event_date"
            },
            {
                key: "platform_status"
            },
            {
                key: "assigned"
            },
            {
                key: "language"
            }
        ];
        me.incidentsAssigned = {
            profile: "incidents_assigned",
            fields: [
                {
                    label: "report_id",
                    key: "report_id",
                    keyAlt: "id",
                    type: "hidden",
                    isPrimary: true,
                    format: "id"
                },
                {
                    label: "1: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).summary,
                    type: "caption"
                },
                //{label: translations.coordinates, key: "coordinates", type: "map",default: "-4,25"},
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).date,
                    key: "date",
                    type: "date",
                    isPrimary: true,
                    isRequired: true,
                    format: "date",
                    default: ()=>(0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(new Date()),
                    onValidate: checkDateIsInPast
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).title,
                    key: "title",
                    type: "text",
                    isPrimary: true,
                    isRequired: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).description,
                    key: "description",
                    type: "textarea"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).status,
                    key: "status",
                    type: "select",
                    values: [
                        "Assign\xe9",
                        "En cours de suivi",
                        "R\xe9solu",
                        "Non r\xe9solu",
                        "Persistant",
                        "Non-Suivi"
                    ],
                    isPrimary: true,
                    enumFilter: true,
                    hideOnEdit: true
                },
                {
                    label: "2: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).incident_type,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).category,
                    key: "category",
                    type: "select",
                    values: Object.keys(categories),
                    child: "subcategory",
                    childValues: categories,
                    isPrimary: true,
                    translate: true,
                    enumFilter: true,
                    isRequired: true,
                    "onChange": setCategoryView
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).children_count,
                    key: "childrenCount",
                    type: "number",
                    collapsed: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).subCategory,
                    key: "subcategory",
                    type: "select",
                    values: [],
                    enumFilter: true,
                    isRequired: true,
                    isPrimary: true,
                    translate: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).subCategory2,
                    key: "subcategory2",
                    type: "select",
                    values: childrenCategories,
                    isPrimary: false,
                    enumFilter: true,
                    translate: true,
                    hasOtherValue: false,
                    collapsed: true
                },
                {
                    label: "3: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).location,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).province,
                    key: "province",
                    type: "select",
                    values: Object.keys(regions),
                    child: "territoire",
                    childValues: regions,
                    isPrimary: true,
                    enumFilter: true,
                    isRequired: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).territory,
                    key: "territoire",
                    master: "province",
                    type: "select",
                    values: [],
                    isPrimary: true,
                    isRequired: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).chiefdomSector,
                    key: "sector",
                    type: "text"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).groupQuarter,
                    key: "group",
                    type: "text"
                },
                {
                    label: "4: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mining_site,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).miningSite,
                    key: "miningsite",
                    type: "text"
                },
                {
                    label: "5: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).responsible_actors,
                    type: "caption"
                },
                {
                    label: "",
                    key: "actors",
                    type: "multiselect",
                    values: responsibleActors,
                    translate: true,
                    enumFilter: false
                },
                {
                    label: "6: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).other,
                    type: "caption"
                },
                {
                    label: "pCode",
                    key: "pcode",
                    type: "text",
                    scope: "owner",
                    "allowEmpty": true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).excludeFromApi,
                    key: "noOpenData",
                    type: "boolean"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).isIncidentCLS,
                    key: "isCLS",
                    type: "boolean"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).lastModified,
                    key: "lastModified",
                    type: "hidden",
                    isPrimary: true,
                    format: "date"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigned,
                    key: "assigned",
                    type: "fk",
                    target: "organisations.name",
                    isPrimary: true,
                    hideOnEdit: true
                }
            ],
            export: true,
            canAdd: true
        };
        me.incidentsInfo = {
            profile: "incidents_info",
            fields: [
                {
                    label: "report_id",
                    key: "report_id",
                    type: "hidden",
                    isPrimary: true
                },
                {
                    label: "1: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).summary,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).date,
                    key: "date",
                    format: "date",
                    type: "date",
                    isPrimary: true,
                    onValidate: checkDateIsInPast
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).title,
                    key: "title",
                    type: "text"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).description,
                    key: "description",
                    type: "textarea"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).status,
                    key: "status",
                    type: "select",
                    values: [
                        "Assign\xe9",
                        "En cours de suivi",
                        "R\xe9solu",
                        "Non r\xe9solu",
                        "Persistant",
                        "Non-Suivi"
                    ],
                    enumFilter: true,
                    hideOnEdit: true
                },
                {
                    label: "2: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).incident_type,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).category,
                    key: "category",
                    type: "select",
                    values: Object.keys(categories),
                    child: "subcategory",
                    childValues: categories,
                    enumFilter: true,
                    translate: true,
                    "onChange": setCategoryView
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).children_count,
                    key: "childrenCount",
                    type: "number",
                    collapsed: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).subCategory,
                    key: "subcategory",
                    type: "select",
                    values: [],
                    isPrimary: true,
                    enumFilter: true,
                    translate: true,
                    hasOtherValue: false
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).subCategory2,
                    key: "subcategory2",
                    type: "select",
                    values: childrenCategories,
                    isPrimary: false,
                    enumFilter: true,
                    translate: true,
                    hasOtherValue: false,
                    collapsed: true
                },
                {
                    label: "3: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).location,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).province,
                    key: "province",
                    type: "select",
                    values: Object.keys(regions),
                    child: "territoire",
                    childValues: regions,
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).territory,
                    key: "territoire",
                    master: "province",
                    type: "select",
                    values: []
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).chiefdomSector,
                    key: "sector",
                    type: "text"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).groupQuarter,
                    key: "group",
                    type: "text"
                },
                {
                    label: "4: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mining_site,
                    type: "caption"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).miningSite,
                    key: "miningsite",
                    type: "text"
                },
                {
                    label: "5: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).responsible_actors,
                    type: "caption",
                    id: "responsibleActorsLabel"
                },
                {
                    label: "",
                    key: "actors",
                    type: "multiselect",
                    values: responsibleActors,
                    translate: true,
                    enumFilter: false,
                    id: "responsibleActors"
                },
                {
                    label: "6: " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).other,
                    type: "caption"
                },
                {
                    label: "pCode",
                    key: "pcode",
                    type: "text",
                    scope: "owner",
                    "allowEmpty": true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).excludeFromApi,
                    key: "noOpenData",
                    type: "boolean"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).isIncidentCLS,
                    key: "isCLS",
                    type: "boolean"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).lastModified,
                    key: "lastModified",
                    type: "hidden",
                    isPrimary: true
                }
            ]
        };
        me.users = {
            profile: "users",
            name: "Utilisateur",
            fields: [
                {
                    label: "id",
                    key: "id",
                    type: "hidden"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).username,
                    key: "username",
                    type: "text",
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fullname,
                    key: "fullname",
                    type: "text",
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).email,
                    key: "email",
                    type: "text",
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).initial,
                    key: "temporaryPassword",
                    type: "password",
                    default: "***"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).role,
                    key: "role",
                    type: "select",
                    values: [
                        {
                            label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).user,
                            value: "user"
                        },
                        {
                            label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).admin,
                            value: "admin"
                        },
                        {
                            label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).owner,
                            value: "owner"
                        }
                    ],
                    isPrimary: true,
                    translate: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).organisation,
                    key: "organisation",
                    type: "fk",
                    target: "organisations.name",
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).preferedLanguage,
                    key: "language",
                    type: "select",
                    values: [
                        "fr",
                        "en"
                    ]
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).emailnotifications,
                    key: "emailnotifications",
                    type: "boolean",
                    default: false
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).active,
                    key: "active",
                    type: "boolean",
                    default: true,
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).lastModified,
                    key: "lastModified",
                    type: "hidden",
                    isPrimary: true,
                    format: "date"
                }
            ],
            export: true,
            canAdd: true,
            canDelete: true
        };
        me.organisations = {
            profile: "organisations",
            name: "Organisation",
            fields: [
                {
                    label: "id",
                    key: "id",
                    type: "hidden"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).shortName,
                    key: "name",
                    type: "text",
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fullName,
                    key: "fullname",
                    type: "text",
                    isPrimary: true
                }
            ],
            export: true,
            canAdd: true,
            canDelete: true
        };
        me.actions = {
            profile: "actions",
            name: "Actions",
            fields: [
                {
                    label: "id",
                    key: "id",
                    type: "hidden"
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).date,
                    key: "date",
                    type: "date",
                    format: "date",
                    isRequired: true,
                    onValidate: checkDateIsInPast
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).action_type,
                    key: "type",
                    type: "select",
                    values: actionTypes,
                    isRequired: true,
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).action_mode,
                    key: "mode",
                    type: "select",
                    values: actionModes,
                    isRequired: true,
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).action_actors,
                    key: "actors",
                    type: "multiselect",
                    values: actionActors,
                    isRequired: true,
                    isPrimary: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).description,
                    key: "description",
                    type: "textarea",
                    isRequired: true,
                    isPrimary: true,
                    translateContent: true
                },
                {
                    label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).lastModified,
                    key: "lastModified",
                    type: "hidden",
                    format: "date"
                }
            ]
        };
    };
    function setCategoryView(value, formConfig) {
        let editor = formConfig.editors.find((editor)=>editor.key === "childrenCount");
        let editor2 = formConfig.editors.find((editor)=>editor.key === "subcategory2");
        let collapsed = value !== "Child labor";
        if (editor) editor.input.closest(".fieldset").classList.toggle("collapsed", collapsed);
        if (editor2) editor2.element.closest(".fieldset").classList.toggle("collapsed", collapsed);
        let actorCategories = [
            "Roadblock",
            "Corruption/Fraud",
            "Environmental issue",
            "Violence",
            "Theft"
        ];
        collapsed = actorCategories.indexOf(value) < 0;
        let actorEditor = formConfig.editors.find((editor)=>editor.key === "actors");
        if (actorEditor) {
            let fieldset = actorEditor.element.closest(".fieldset");
            let label = fieldset.previousSibling;
            fieldset.classList.toggle("collapsed", collapsed);
            if (label) label.classList.toggle("collapsed", collapsed);
        }
    }
    function checkChildLabourValue(editors, value) {
        if (value) return true;
        let categoryEditor = editors.find((item)=>item.key === "category");
        if (categoryEditor) {
            let parentValue = categoryEditor.input ? categoryEditor.input.value : categoryEditor.getValue();
            if (parentValue === "Child labor" && !value) return false;
        }
        return true;
    }
    function checkDateIsInPast(editors, value) {
        if (!value) return false;
        const now = new Date();
        const margin = 7200000; // 2 hours in milliseconds
        const futureTime = now.getTime() + margin;
        let date = new Date(value);
        // check for invalid date
        if (isNaN(date.getTime())) return false;
        let isInPast = date.getTime() < futureTime;
        return isInPast;
    }
    return me;
})();
var $27ed2bfcca54492f$export$2e2bcd8739ae039 = $27ed2bfcca54492f$var$Data;




let $a979bca9e51c7bc2$var$Logger = (()=>{
    let me = {};
    me.log = (type, incident, organisation)=>{
        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("logs", {
            user: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            incident: incident,
            organisation: organisation,
            type: type
        });
    };
    return me;
})();
var $a979bca9e51c7bc2$export$2e2bcd8739ae039 = $a979bca9e51c7bc2$var$Logger;




let $e34ba239425160f5$var$MasterDetail = (()=>{
    let me = {};
    let formContainer;
    let filterButtons = {};
    let currentConfig;
    let currentItemList;
    let currentDataItem;
    let currentNav;
    let rowData = {};
    let cols = [];
    me.render = async (container, config)=>{
        (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).waiting(true);
        let row, searchRow, itemList, buttons;
        currentConfig = config;
        cols = [];
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".list", {
            parent: container
        }, formContainer = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".sideform", {
            parent: container
        }), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".sidescroll", row = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".header"), searchRow = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".searchrow", {
            parent: container
        }), itemList = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".itemlist", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".loadertext", "Chargement"))), buttons = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttons"));
        let first = true;
        let colIndex = 0;
        config.fields.forEach((field)=>{
            if (!field.isPrimary) return;
            let className = field.className || "";
            if (className) className = "." + className;
            if (config.sort === field.key) className += "." + config.sortOrder;
            let label;
            row.appendChild(label = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label.cell" + className, {
                onClick: ()=>{
                    if (config.sort === field.key) config.sortOrder = config.sortOrder === "asc" ? "desc" : "asc";
                    else config.sortOrder = "asc";
                    config.sort = field.key;
                    row.querySelectorAll("label").forEach((label)=>{
                        label.classList.remove("asc", "desc");
                    });
                    label.classList.add(config.sortOrder);
                    renderList(config, itemList);
                },
                colIndex: colIndex
            }, filterButtons[field.key] = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".filterbutton", {
                onClick: ()=>{
                    if (!searchRow.innerHTML) renderSearch(config, searchRow, itemList, label);
                    searchRow.classList.toggle("active");
                }
            }), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".sizer", {
                onClick: ()=>{
                    let rect = label.getBoundingClientRect();
                    rowData[field.key] = rect.width;
                    rowData.startW = rect.width;
                    rowData.sizeColIndex = label.colIndex;
                },
                onDrag: (touchData)=>{
                    let w = rowData.startW + touchData.deltaX;
                    if (w < 50) w = 50;
                    label.style.width = w + "px";
                    let colCells = itemList.querySelectorAll(".col" + rowData.sizeColIndex);
                    colCells.forEach((cell)=>{
                        let cw = w;
                        if (rowData.sizeColIndex === 0) cw -= 24;
                        cell.style.width = cw + "px";
                    });
                    let searchCells = searchRow.querySelectorAll(".col" + rowData.sizeColIndex);
                    searchCells.forEach((cell)=>{
                        let cw = w;
                        //if (rowData.sizeColIndex === 0) cw -= 24;
                        cell.style.width = cw + "px";
                    });
                    rowData[field.key] = w;
                },
                onUp: ()=>{
                //console.error("up");
                }
            }), field.label));
            if (field.size) {
                let size = field.size;
                if (first) size += 32;
                label.style.width = size + "px";
            }
            if (rowData[field.key]) label.style.width = rowData[field.key] + "px";
            first = false;
            colIndex++;
        });
        currentNav = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".nav", {
            parent: buttons
        });
        let canAdd = config.canAdd;
        if (config.preFilterName) {
            if (config.preFilterName === "open") canAdd = false;
            if (config.preFilterName === "closed") canAdd = false;
        }
        if (canAdd) (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green.add", {
            parent: buttons,
            onClick: ()=>{
                generateForm(config);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).add);
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.blue.export", {
            parent: buttons,
            onClick: (e)=>{
                let button = e.target.closest("button");
                if (button) button.classList.add("loading");
                exportData(config).then(()=>{
                    if (button) button.classList.remove("loading");
                });
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).export);
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.delete.filterbutton.hidden", {
            parent: buttons,
            onClick: (e)=>{
                config.filter = undefined;
                searchRow.innerHTML = "";
                if (searchRow.classList.contains("active")) renderSearch(config, searchRow, itemList);
                for(let key in filterButtons)filterButtons[key].classList.remove("active");
                renderList(config, itemList);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).clearFilter);
        if (config.buttons) config.buttons.forEach((button)=>{
            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green", {
                parent: buttons,
                onClick: button.onClick
            }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), button.label);
        });
        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolveAll(config).then(()=>{
            renderList(config, itemList).then((count)=>{});
        });
    };
    me.closeSidePanel = ()=>{
        let form = formContainer.querySelector(".form");
        let form2 = formContainer.querySelector(".form2");
        if (form) {
            form.classList.add("out");
            setTimeout(()=>{
                formContainer.classList.remove("active");
            }, 500);
        }
        if (form2) form2.classList.add("out");
        let hash = window.location.hash;
        if (hash.indexOf("/") > 0) {
            let parts = hash.split("/");
            let id = parseInt(parts.pop());
            if (!isNaN(id)) window.location.hash = parts.join("/");
        }
    };
    me.refresh = ()=>{
        renderList(currentConfig, currentItemList);
    };
    me.double = async function(config, readOnly) {
        formContainer.classList.add("double");
        let form2 = formContainer.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".form.form2.generic", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).informationAfterFollowUp)));
        let obj = currentDataItem;
        if (obj.id && typeof obj.id === "string" && obj.id.indexOf("-") > 0) await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("incidents", obj.id).then((result)=>{
            if (result) {
                let newKeys = Object.keys(result);
                let oldKeys = Object.keys(obj);
                newKeys.forEach((key)=>{
                    if (!oldKeys.includes(key)) obj[key] = result[key];
                });
            }
        });
        //readOnly = false;
        if (readOnly) {
            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".detail.indent", {
                parent: form2
            }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("table", {
                parent: form2
            }, config.fields.map((field)=>{
                let key = field.key;
                let value = obj[key];
                let show = !field.hideOnEdit;
                if (!show) return;
                if (value && field.translate) value = (0, $150917cc518d921d$export$2e2bcd8739ae039).map(value);
                //console.log(field.type)
                if (field.format === "date" || field.key === "lastModified") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
                if (field.type === "boolean") value = value ? (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes : (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no;
                let td = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", "" + value);
                if (value || typeof value === "number") {
                    let label = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(field.label)] || field.label || key;
                    let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[label.toLowerCase().split(" ").join("_")];
                    label = translated || label;
                    return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", "" + label), td);
                }
            })));
            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttons", {
                parent: form2
            }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red.delete", {
                onClick: ()=>{
                    me.closeSidePanel();
                }
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).close));
            return;
        }
        config.editors = [];
        config.fields.forEach((field)=>{
            let show = !field.hideOnEdit;
            if (field.scope === "owner" && !(0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner()) show = false;
            if (field.type === "caption") {
                let c = {
                    parent: form2
                };
                if (field.id) c.id = field.id;
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h5", c, field.label);
            } else if (show) config.editors.push(generateEditor(form2, field, obj, config));
        });
        let buttonSave;
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttons", {
            parent: form2
        }, buttonSave = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green", {
            onClick: ()=>{
                if (buttonSave.classList.contains("loading")) return;
                buttonSave.classList.add("loading");
                let obj = {};
                /*

                config.editors.forEach(editor=>{
                    let value = editor.input?editor.input.value:editor.getValue();
                    if (value || typeof value === "boolean" || typeof value === "number") obj[editor.key] = value;

                    if (editor.input) editor.input.classList.remove("error");
                    if (editor.element) editor.element.classList.remove("error");

                    let field =config.fields.find(field=>field.key===editor.key);
                    if (field){
                        if (field.isRequired && !value){
                            isValid = false;
                            if (editor.input) editor.input.classList.add("error");
                            if (editor.element) editor.element.classList.add("error");
                        }
                    }
                });

                 */ let isValid = true;
                config.editors.forEach((editor)=>{
                    let value = editor.input ? editor.input.value : editor.getValue();
                    if (value || typeof value === "boolean" || typeof value === "number") obj[editor.key] = value;
                    else {
                        let field = config.fields.find((field)=>field.key === editor.key);
                        if (field && field.allowEmpty) obj[editor.key] = value;
                    }
                    if (editor.input) editor.input.classList.remove("error");
                    if (editor.element) editor.element.classList.remove("error");
                    let field = config.fields.find((field)=>field.key === editor.key);
                    if (field) {
                        if (field.isRequired && !value) {
                            isValid = false;
                            if (editor.input) editor.input.classList.add("error");
                            if (editor.element) editor.element.classList.add("error");
                        }
                        if (field.onValidate) {
                            let result = field.onValidate(config.editors, value);
                            if (!result) {
                                isValid = false;
                                setTimeout(()=>{
                                    if (editor.input) editor.input.classList.add("error");
                                    if (editor.element) editor.element.classList.add("error");
                                }, 5);
                            }
                        }
                    }
                });
                if (!obj.id && currentDataItem.id) obj.id = currentDataItem.id;
                if (config.profile === "incidents_info") obj.id = currentDataItem.info_id;
                if (!isValid) {
                    form2.classList.add("inerror");
                    buttonSave.classList.remove("loading");
                    buttonSave.classList.add("error");
                    setTimeout(()=>{
                        buttonSave.classList.remove("error");
                    }, 1000);
                    return;
                }
                (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update(config.profile, obj).then((result)=>{
                    if (config.profile === "incidents_info") obj.id = currentDataItem.id;
                    (0, $1405dab32d7e0174$export$2e2bcd8739ae039).updateCache("incidents_assigned", obj);
                    me.refresh();
                    buttonSave.classList.remove("loading");
                    me.closeSidePanel();
                });
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).save), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red.delete", {
            onClick: ()=>{
                me.closeSidePanel();
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel), config.additionalButtons ? config.additionalButtons(obj) : undefined);
    };
    me.generateForm = (config, onSave, onCancel, onDelete, obj)=>{
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".generic");
        config.editors = [];
        config.fields.forEach((field)=>{
            config.editors.push(generateEditor(form, field, obj));
        });
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".errormessage", {
            parent: form
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fill_in_required_fields);
        let button;
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttons", {
            parent: form
        }, button = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.green", {
            onClick: (event, button)=>{
                if (button.classList.contains("loading")) return;
                button.classList.add("loading");
                let obj = {};
                let isValid = true;
                form.classList.remove("inerror");
                button.classList.remove("error");
                config.editors.forEach((editor)=>{
                    let value = editor.input ? editor.input.value : editor.getValue();
                    if (value || typeof value === "boolean" || typeof value === "number") obj[editor.key] = value;
                    if (editor.input) editor.input.classList.remove("error");
                    if (editor.element) editor.element.classList.remove("error");
                    let field = config.fields.find((field)=>field.key === editor.key);
                    if (field) {
                        if (field.isRequired && !value) {
                            isValid = false;
                            if (editor.input) editor.input.classList.add("error");
                            if (editor.element) editor.element.classList.add("error");
                        }
                        if (field.onValidate) {
                            let result = field.onValidate(config.editors, value);
                            if (!result) {
                                isValid = false;
                                setTimeout(()=>{
                                    if (editor.input) editor.input.classList.add("error");
                                    if (editor.element) editor.element.classList.add("error");
                                }, 5);
                            }
                        }
                    }
                });
                if (!isValid) {
                    button.classList.add("error");
                    button.classList.remove("loading");
                    form.classList.add("inerror");
                    return;
                }
                onSave(obj).then(()=>{
                    button.classList.remove("loading");
                });
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).save), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.blue.delete", {
            onClick: onCancel
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel), onDelete && obj && obj.id ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: ()=>{
                onDelete(obj);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).delete) : undefined);
        return form;
    };
    function renderSearch(config, parent, itemList) {
        let first = true;
        let rowIndex = 0;
        config.fields.forEach((field)=>{
            if (!field.isPrimary) return;
            let className = field.className || "";
            if (className) className = "." + className;
            className += " col" + rowIndex;
            let input, cell;
            parent.appendChild(cell = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label.cell" + className, input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                placeholder: field.label,
                onkeyup: ()=>{
                    let value = input.value.toLowerCase();
                    config.filter = config.filter || {};
                    config.filter[field.key] = config.filter[field.key] || {};
                    config.filter[field.key].match = value;
                    (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolveAll(config).then(()=>{
                        renderList(config, itemList);
                    });
                },
                value: config.filter && config.filter[field.key] && config.filter[field.key].match || ""
            })));
            if (field.type === "date" || field.format === "date") {
                let fromInput, toInput;
                let fromRow, toRow;
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".dateselectbox", {
                    parent: cell
                }, fromRow = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".datebox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).from), fromInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    type: "text"
                })), toRow = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".datebox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).to), toInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    type: "text"
                })));
                let fromValue = config.filter && config.filter[field.key] && config.filter[field.key].from;
                let toValue = config.filter && config.filter[field.key] && config.filter[field.key].to;
                function setValue(type) {
                    return (value)=>{
                        config.filter = config.filter || {};
                        config.filter[field.key] = config.filter[field.key] || {};
                        config.filter[field.key][type] = value;
                        let d = new Date(value);
                        if (isNaN(d.getTime())) config.filter[field.key][type + "Date"] = undefined;
                        else config.filter[field.key][type + "Date"] = d;
                        renderList(config, itemList);
                    };
                }
                fromRow.appendChild(generateDatePicker(fromInput, fromValue, true, setValue("from")));
                toRow.appendChild(generateDatePicker(toInput, toValue, true, setValue("to")));
            }
            if (field.enumFilter) {
                parent.classList.add("enumfilter");
                let filterBox = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".filterbox", {
                    parent: cell
                });
                let keyList = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".keylist", {
                    parent: filterBox
                });
                (0, $1405dab32d7e0174$export$2e2bcd8739ae039).distinct(config.profile, field.key, config.preFilterName).then((data)=>{
                    let sKeys = [];
                    data.forEach((item)=>{
                        let key = item[field.key];
                        if (!key) return;
                        let isChecked = config.filter && config.filter[field.key] && config.filter[field.key].values && config.filter[field.key].values.includes("" + key);
                        let sKey = "" + key;
                        if (field.translate) sKey = (0, $150917cc518d921d$export$2e2bcd8739ae039).map(sKey);
                        sKeys.push({
                            key: key,
                            value: sKey,
                            checked: isChecked
                        });
                    });
                    sKeys = sKeys.sort((a, b)=>{
                        if (a.value < b.value) return -1;
                        if (a.value > b.value) return 1;
                        return 0;
                    });
                    sKeys.forEach((sKey)=>{
                        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".key" + (sKey.checked ? ".checked" : ""), {
                            parent: keyList,
                            value: sKey.key,
                            onClick: (e)=>{
                                e.target.classList.toggle("checked");
                                let values = [];
                                keyList.querySelectorAll(".key.checked").forEach((key)=>{
                                    values.push(key.value);
                                });
                                config.filter = config.filter || {};
                                config.filter[field.key] = config.filter[field.key] || {};
                                config.filter[field.key].values = values;
                                config.filter[field.key].valuesTranslated = values.map((0, $150917cc518d921d$export$2e2bcd8739ae039).map);
                                renderList(config, itemList);
                            }
                        }, sKey.value);
                    });
                });
            }
            if (field.size) {
                let size = field.size;
                if (first) size += 32;
                cell.style.width = size + "px";
            }
            if (rowData[field.key]) {
                let cw = rowData[field.key];
                cell.style.width = cw + "px";
            }
            first = false;
            rowIndex++;
        });
    }
    function renderList(config, parent) {
        return new Promise(async (next)=>{
            currentItemList = parent;
            let data = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list(config.profile);
            (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).waiting(false);
            parent.innerHTML = "";
            if (config.preFilter) data = data.filter(config.preFilter);
            if (data && data.length) {
                if (config.sort) {
                    sortList(data, config.sort);
                    if (config.sortOrder === "desc") data.reverse();
                }
                if (config.filter) {
                    let filterKeys = Object.keys(config.filter);
                    filterKeys.forEach((key)=>{
                        let filter = config.filter[key];
                        filterButtons[key].classList.toggle("active", !!(filter.match || filter.from || filter.to || filter.values && filter.values.length));
                    });
                    data = data.filter((item)=>{
                        let passed = true;
                        filterKeys.forEach((key)=>{
                            let filter = config.filter[key];
                            let filterValue = "" + (item[key + "_resolved"] || item[key]);
                            if (filter.match) // this is a free text search -> filter on the display value (=resolved value)
                            {
                                if (filterValue.toLowerCase().indexOf(filter.match) < 0) passed = false;
                            }
                            if (filter.values && filter.values.length) // this is a filter with pre-defined values (coming from an enum select list) -> filter on the actual value
                            {
                                if (!filter.values.includes(item[key])) passed = false;
                            }
                            if (filter.from || filter.to) {
                                // this is a date filter
                                let date = new Date(filterValue);
                                if (filter.fromDate) {
                                    if (date < filter.fromDate) passed = false;
                                }
                                if (filter.toDate) {
                                    if (date > filter.toDate) passed = false;
                                }
                            }
                        });
                        return passed;
                    });
                }
                let startPage = config.page || 0;
                let startIndex = startPage * 100;
                if (startIndex >= data.length) {
                    config.page = 0;
                    startIndex = 0;
                }
                let endIndex = startIndex + 100;
                let max = Math.min(data.length, endIndex);
                for(let i = startIndex; i < max; i++){
                    let item = data[i];
                    let first = true;
                    let colIndex = 0;
                    let row = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".row", {
                        parent: parent,
                        onClick: (e)=>{
                            let row = e.target.closest(".row");
                            parent.querySelectorAll(".row").forEach((row)=>{
                                row.classList.remove("selected");
                            });
                            row.classList.add("selected");
                            generateForm(config, item);
                        }
                    }, deleteButton(config, item.id), config.fields.map((field)=>{
                        if (!field.isPrimary) return;
                        let cell;
                        let value = "" + (item[field.key] || "");
                        if (!value && field.keyAlt) value = "" + (item[field.keyAlt] || "");
                        if (field.type === "fk") {
                            let profile = field.target.split(".")[0];
                            let fieldName = field.target.split(".")[1] || "id";
                            (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById(profile, value).then((result)=>{
                                if (result) {
                                    cell.innerHTML = result[fieldName];
                                    item[field.key + "_resolved"] = result[fieldName];
                                }
                            });
                            value = "";
                        }
                        if (field.type === "boolean") {
                            value = value === "true" ? (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes : (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no;
                            item[field.key + "_resolved"] = value;
                        }
                        if (field.translate) {
                            value = (0, $150917cc518d921d$export$2e2bcd8739ae039).map(value);
                            item[field.key + "_resolved"] = value;
                        }
                        if (field.format === "date") {
                            value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
                            item[field.key + "_resolved"] = value;
                        }
                        if (field.format === "id" && value && value.indexOf("-") > 0) {
                            value = value.split("-")[0];
                            item[field.key + "_resolved"] = value;
                        }
                        let className = field.className || "";
                        if (className) className = "." + className;
                        className += " col" + colIndex;
                        cell = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div.cell" + className, value);
                        if (field.size) cell.style.width = field.size + "px";
                        else {
                            if (first) cell.style.width = "126px";
                            if (first) cell.style.width = "126px";
                        }
                        if (rowData[field.key]) {
                            let cw = rowData[field.key];
                            if (first) cw -= 24;
                            cell.style.width = cw + "px";
                        }
                        first = false;
                        colIndex++;
                        return cell;
                    }));
                    if (config.openDetailId && (config.openDetailId === item.id || config.openDetailId === item.report_id)) row.classList.add("selected");
                }
                if (currentNav) {
                    currentNav.innerHTML = "";
                    let info = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".info", {
                        parent: currentNav
                    }, startIndex + 1 + "-" + max + " of " + data.length);
                    let count = data.length;
                    let pages = Math.ceil(count / 100);
                    (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".button.prev" + (startPage < 1 ? ".inactive" : ""), {
                        parent: currentNav,
                        onClick: ()=>{
                            config.page = startPage - 1;
                            renderList(config, parent);
                        }
                    });
                    (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".button.next" + (startPage >= pages - 1 ? ".inactive" : ""), {
                        parent: currentNav,
                        onClick: ()=>{
                            config.page = startPage + 1;
                            renderList(config, parent);
                        }
                    });
                    let buttons = currentNav.closest(".buttons");
                    if (buttons) {
                        let filterButton = buttons.querySelector(".filterbutton");
                        if (filterButton) filterButton.classList.toggle("hidden", !config.filter);
                    }
                }
                if (config.openDetailId) {
                    let row = parent.querySelector(".row.selected");
                    if (row) row.scrollIntoView();
                    let item = data.find((item)=>item.id === config.openDetailId || item.report_id == config.openDetailId);
                    if (item) generateForm(config, item);
                    else {
                        console.error("Item not found", config.openDetailId);
                        console.error(data);
                    }
                }
                next(data.length);
            } else {
                parent.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".loadertext", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).noData));
                if (currentNav) currentNav.innerHTML = "";
                next(0);
            }
        });
    }
    function generateForm(config, obj) {
        let isNew = !obj;
        obj = obj || {};
        currentDataItem = obj;
        formContainer.innerHTML = "";
        formContainer.classList.remove("double");
        let title = !isNew ? (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).edit + " " + config.name : (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).new + " " + (config.name || "incident");
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".form.generic", {
            parent: formContainer
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", title), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".closebutton.light", {
            onClick: me.closeSidePanel
        }));
        if (config.detail && !isNew) config.detail(obj, form);
        else {
            config.editors = [];
            config.fields.forEach((field)=>{
                let show = !field.hideOnEdit;
                if (field.scope === "owner" && !(0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner()) show = false;
                if (show) {
                    if (field.type === "caption") (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h5", {
                        parent: form
                    }, field.label);
                    else config.editors.push(generateEditor(form, field, obj, config));
                }
            });
            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".errormessage", {
                parent: form
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fill_in_required_fields);
            let button;
            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttons", {
                parent: form
            }, button = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green", {
                onClick: ()=>{
                    if (button.classList.contains("loading")) return;
                    button.classList.add("loading");
                    let obj = {};
                    let isValid = true;
                    form.classList.remove("inerror");
                    button.classList.remove("error");
                    config.editors.forEach((editor)=>{
                        let value = editor.input ? editor.input.value : editor.getValue();
                        if (value || typeof value === "boolean" || typeof value === "number") obj[editor.key] = value;
                        if (editor.input) editor.input.classList.remove("error");
                        let field = config.fields.find((field)=>field.key === editor.key);
                        if (field) {
                            if (field.isRequired && !value) {
                                isValid = false;
                                if (editor.input) editor.input.classList.add("error");
                            }
                            if (field.type === "map") {
                                let co = value.split(",");
                                obj.latitude = parseFloat(co[0]);
                                obj.longitude = parseFloat(co[1]);
                                if (isNaN(obj.latitude) || isNaN(obj.longitude)) {
                                    obj.latitude = 0;
                                    obj.longitude = 0;
                                }
                            }
                            if (field.onValidate) {
                                let result = field.onValidate(config.editors, value);
                                if (!result) {
                                    isValid = false;
                                    if (editor.input) editor.input.classList.add("error");
                                }
                            }
                        }
                    });
                    if (!isValid) {
                        button.classList.add("error");
                        button.classList.remove("loading");
                        form.classList.add("inerror");
                        return;
                    }
                    if (config.postProcessing) config.postProcessing(obj);
                    (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update(config.profile, obj).then(async (result)=>{
                        if (config.postUpdate) await config.postUpdate(obj, result, isNew);
                        me.refresh();
                        button.classList.remove("loading");
                        me.closeSidePanel();
                    });
                }
            }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).save), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red.delete", {
                onClick: me.closeSidePanel
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel));
        }
        setTimeout(()=>{
            formContainer.classList.add("active");
        }, 20);
    }
    function generateEditor(parent, config, obj, formConfig) {
        obj = obj || {};
        let editor = {
            key: config.key
        };
        let value = obj[config.key];
        if (!value) {
            if (config.type !== "boolean") {
                value = config.default;
                if (typeof value === "function") value = value(obj);
                console.log(value);
            } else if (typeof value === "undefined" && typeof config.default === "boolean") value = config.default;
        }
        let c = {
            parent: parent
        };
        if (config.id) c.id = config.id;
        let editorElm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".fieldset", c, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", config.label));
        if (config.collapsed) editorElm.classList.add("collapsed");
        switch(config.type){
            case "select":
                let hasSelection = false;
                let otherValue = "";
                if (value && value.indexOf("(") >= 0) {
                    let p = value.indexOf("(");
                    otherValue = value.substring(p + 1).replace(")", "");
                    value = value.substring(0, p).trim();
                }
                let select;
                let otherInput;
                editor.onChange = [];
                editor.element = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".select", {
                    parent: editorElm
                }, select = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("select", config.values.map((val)=>{
                    if (typeof val === "string") val = {
                        label: val,
                        value: val
                    };
                    if (val.value === value) hasSelection = true;
                    if (config.translate) val.label = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(val.label)] || val.label;
                    return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                        value: val.value,
                        selected: value === val.value
                    }, val.label);
                })));
                if (!hasSelection) select.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                    value: value || "",
                    selected: true
                }, value || (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).pleaseSelect));
                select.onchange = ()=>{
                    editor.onChange.forEach((callback)=>{
                        callback();
                    });
                };
                if (config.child) {
                    //let subSelect = $("select.capitalize",{parent:editorElm});
                    editor.onChange.push(()=>{
                        let value = select.value;
                        let childElement = formConfig.editors.find((editor)=>editor.key === config.child);
                        let childSelect = childElement.element.querySelector("select");
                        if (childSelect) {
                            let currentValue = childSelect.value;
                            childSelect.innerHTML = "";
                            let values = (config.childValues[value] || []).slice();
                            //values.unshift("");
                            let hasChildSelection;
                            values.forEach((val)=>{
                                let label = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(val)] || val;
                                childSelect.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                                    value: val,
                                    selected: val === currentValue
                                }, label));
                                if (val === currentValue) hasChildSelection = true;
                            });
                            if (!hasChildSelection) childSelect.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                                value: "",
                                selected: true
                            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).pleaseSelect));
                        }
                    });
                    setTimeout(()=>{
                        select.onchange();
                    }, 100);
                }
                if (config.hasOtherValue) {
                    otherInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                        parent: editorElm,
                        value: otherValue,
                        placeholder: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).otherValue
                    });
                    editor.onChange.push(()=>{
                        let value = (select.value || "").toLowerCase();
                        otherInput.style.display = value === "other" ? "block" : "none";
                    });
                    setTimeout(()=>{
                        select.onchange();
                    }, 100);
                }
                if (config.onChange) {
                    editor.onChange.push(()=>{
                        config.onChange(select.value, formConfig);
                    });
                    setTimeout(()=>{
                        select.onchange();
                    }, 100);
                }
                editor.getValue = ()=>{
                    let value = select.value || "";
                    if (otherInput && value.toLowerCase() === "other") value += " (" + otherInput.value + ")";
                    return value;
                };
                break;
            case "multiselect":
                let values = [];
                let other = "";
                if (value) {
                    values = value.split(", ");
                    let otherIndex = values.findIndex((val)=>val.startsWith("other"));
                    if (otherIndex >= 0) {
                        other = values[otherIndex];
                        let p = other.indexOf("(");
                        if (p > 0) other = other.substring(p + 1).replace(")", "");
                        values[otherIndex] = "other";
                    }
                }
                editor.element = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".multiselect", {
                    parent: editorElm
                }, config.values.map((val)=>{
                    if (typeof val === "string") val = {
                        label: val,
                        value: val
                    };
                    let children;
                    if (config.childValues) {
                        let childValues = config.childValues[val.value];
                        if (childValues && childValues.length) children = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".children", childValues.map((child)=>{
                            let label = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(child)] || child;
                            let input = child === "other" ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                                onClick: ()=>{}
                            }) : undefined;
                            return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".cb", {
                                onClick: (e, elm)=>{
                                    elm.classList.toggle("active");
                                },
                                onUp: (e, elm)=>{
                                    if (input && elm.classList.contains("active")) input.focus();
                                },
                                value: child
                            }, label, input);
                        }));
                    }
                    let label = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(val.label)] || val.label;
                    let input = val.label === "other" ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                        onClick: ()=>{},
                        value: other
                    }) : undefined;
                    let isChecked = values.includes(val.value);
                    return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".cbfield", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".cb" + (isChecked ? ".active" : ""), {
                        onClick: (e, elm)=>{
                            elm.classList.toggle("active");
                        },
                        onUp: (e, elm)=>{
                            if (input && elm.classList.contains("active")) input.focus();
                        },
                        value: val.value
                    }, label, input), children);
                }));
                editor.getValue = ()=>{
                    let values = [];
                    editor.element.querySelectorAll(".cb.active").forEach((cb)=>{
                        values.push(cb.value);
                    });
                    return values.join(", ");
                };
                break;
            case "fk":
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("select", {
                    parent: editorElm
                }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                    value: ""
                }, ""));
                let profile = config.target.split(".")[0];
                let field = config.target.split(".")[1] || "id";
                (0, $1405dab32d7e0174$export$2e2bcd8739ae039).distinct(profile, field).then((data)=>{
                    data.forEach((item)=>{
                        editor.input.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                            value: item.id,
                            selected: value === item.id
                        }, item[field]));
                    });
                });
                break;
            case "textarea":
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("textarea", {
                    parent: editorElm,
                    value: value || ""
                });
                break;
            case "boolean":
                let checkbox = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".yesno", {
                    parent: editorElm,
                    onClick: ()=>{
                        checkbox.classList.toggle("active");
                        onInput();
                    }
                }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes));
                let onInput = ()=>{};
                if (config.children) onInput = ()=>{
                    let value = checkbox.classList.contains("active");
                    config.children.forEach((child)=>{
                        let childEditor = formConfig.editors.find((editor)=>editor.key === child);
                        if (childEditor && childEditor.input) childEditor.input.closest(".fieldset").classList.toggle("collapsed", !value);
                    });
                };
                editorElm.classList.add("single");
                if (value) checkbox.classList.add("active");
                if (onInput()) setTimeout(()=>{
                    onInput();
                }, 100);
                editor.getValue = ()=>{
                    return checkbox.classList.contains("active");
                };
                break;
            case "collection":
                let fields = config.fields;
                let collection = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".collection", {
                    parent: editorElm
                });
                let sublist = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".sublist", {
                    parent: collection
                });
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.icon.add.nobackground", {
                    parent: collection,
                    onClick: ()=>{
                        let row = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".subrow", {
                            parent: sublist
                        });
                        fields.forEach((field)=>{
                            generateEditor(row, field);
                        });
                    }
                });
                break;
            case "hidden":
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    parent: editorElm,
                    value: value || "",
                    type: "hidden"
                });
                editorElm.classList.add("hidden");
                break;
            case "password":
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    type: "password",
                    autocomplete: "off",
                    parent: editorElm,
                    value: value || ""
                });
                break;
            case "map":
                let map = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".map", {
                    id: "mapView",
                    parent: editorElm
                });
                map.style.height = "200px";
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    parent: editorElm,
                    value: value || ""
                });
                showMap(editorElm, -4.6, 25.2, true, editor.input);
                break;
            case "text":
                if (config.format === "date") {
                    if (value) value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
                }
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    parent: editorElm,
                    value: value || "",
                    type: "text"
                });
                break;
            case "number":
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    parent: editorElm,
                    value: value || "",
                    type: "number",
                    min: 0
                });
                break;
            case "date":
                if (value) value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    parent: editorElm,
                    value: value || "",
                    type: "text"
                });
                editorElm.appendChild(generateDatePicker(editor.input, value));
                break;
            default:
                editor.input = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    parent: editorElm,
                    value: value || ""
                });
        }
        return editor;
    }
    function showMap(parent, lat, lng, dragMarker, coElm) {
        mapboxgl.accessToken = "pk.eyJ1IjoiaXBpc3Jlc2VhcmNoIiwiYSI6IklBazVQTWcifQ.K13FKWN_xlKPJFj9XjkmbQ";
        const map = new mapboxgl.Map({
            container: "mapView",
            style: "mapbox://styles/mapbox/streets-v12",
            center: [
                lng,
                lat
            ],
            zoom: 9 // starting zoom
        });
        const marker = new mapboxgl.Marker({
            draggable: dragMarker
        }).setLngLat([
            lng,
            lat
        ]).addTo(map);
        marker.on("dragend", ()=>{
            const co = marker.getLngLat();
            coElm.value = co.lat.toFixed(7) + ", " + co.lng.toFixed(7);
        //coordinates.style.display = 'block';
        //coordinates.innerHTML = `Longitude: ${lngLat.lng}<br />Latitude: ${lngLat.lat}`;
        });
    }
    function deleteButton(config, key) {
        return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".button.icon.delete" + (config.canDelete ? ".active" : ""), {
            title: "Delete",
            onClick: (e)=>{
                e.stopPropagation();
                let row = e.target.closest(".row");
                row.classList.add("removing");
                let confirm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".confirm", {
                    onClick: (e)=>{
                        e.stopPropagation();
                    }
                }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).deleteItemQuestion, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.small", {
                    onClick: ()=>{
                        row.removeChild(confirm);
                        row.classList.add("loading");
                        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).delete(config.profile, key).then((result)=>{
                            if (result.status === "ok") row.parentNode.removeChild(row);
                            else {
                                row.classList.remove("loading");
                                row.classList.remove("removing");
                                row.classList.add("error");
                            }
                        });
                    }
                }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.small", {
                    onClick: ()=>{
                        row.classList.remove("removing");
                        row.removeChild(confirm);
                    }
                }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no));
                row.appendChild(confirm);
                setTimeout(()=>{
                    confirm.classList.add("active");
                }, 10);
            }
        });
    }
    function sortList(data, sort) {
        data.sort((a, b)=>{
            let valueA = a[sort + "_resolved"] || a[sort] || "";
            let valueB = b[sort + "_resolved"] || b[sort] || "";
            if (typeof valueA === "string") valueA = valueA.toLowerCase();
            if (typeof valueB === "string") valueB = valueB.toLowerCase();
            if (valueA < valueB) return -1;
            if (valueA > valueB) return 1;
            return 0;
        });
    }
    async function exportData(config) {
        let data = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).dump(config.profile, config.preFilterName);
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolveAll(config, data);
        let organisations = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).distinct("organisations", "name");
        let users = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).distinct("users", "fullname");
        let orgFields = [
            "assigned",
            "organisation"
        ];
        let userFields = [
            "assignedBy",
            "archivedBy",
            "acceptedBy",
            "rejectedBy",
            "closedBy"
        ];
        let dateFields = [
            "assignedOn",
            "archivedOn",
            "acceptedOn",
            "rejectedOn",
            "closedOn",
            "date",
            "lastModified"
        ];
        let countComments = config.profile.indexOf("incidents") >= 0;
        let comments = [];
        if (countComments) comments = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).get("comments?fields=incident");
        if (config.filter) {
            let filterKeys = Object.keys(config.filter);
            data = data.filter((item)=>{
                let passed = true;
                filterKeys.forEach((key)=>{
                    let filter = config.filter[key];
                    let filterValue = "" + (item[key + "_resolved"] || item[key]);
                    if (filter.match) {
                        if (filterValue.toLowerCase().indexOf(filter.match) < 0) passed = false;
                    }
                    if (filter.values && filter.values.length) {
                        let hasValue = filter.values.includes(filterValue);
                        if (!hasValue && filter.valuesTranslated) hasValue = filter.valuesTranslated.includes(filterValue);
                        if (!hasValue) passed = false;
                    }
                    if (filter.from || filter.to) {
                        let date = new Date(filterValue);
                        if (filter.fromDate) {
                            if (date < filter.fromDate) passed = false;
                        }
                        if (filter.toDate) {
                            if (date > filter.toDate) passed = false;
                        }
                    }
                });
                return passed;
            });
        }
        // consolidate all keys
        let keyMap = {};
        data.forEach((item)=>{
            if (countComments) item.commentCount = 0;
            Object.keys(item).forEach((key)=>{
                if (key.indexOf("_resolved") >= 0) return;
                keyMap[key] = true;
                if (countComments && key.startsWith("platform_comment_") && item[key]) item.commentCount++;
            });
            orgFields.forEach((field)=>{
                let value = item[field];
                if (value) {
                    let org = organisations.find((org)=>org.id === value);
                    if (org) item[field] = org.name;
                }
            });
            userFields.forEach((field)=>{
                let value = item[field];
                if (value) {
                    let user = users.find((user)=>user.id === value);
                    if (user) item[field] = user.fullname;
                }
            });
            dateFields.forEach((field)=>{
                let value = item[field];
                if (value && typeof value === "number") item[field] = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            });
            if (countComments) {
                let id = item.report_id || item.id;
                let itemComments = comments.filter((comment)=>comment.incident == id);
                item.commentCount += itemComments.length;
            }
        });
        if (countComments) {
            for(let i = 1; i < 11; i++)delete keyMap["platform_comment_" + i];
            keyMap["commentCount"] = true;
        }
        delete keyMap["info_id"];
        let keys = Object.keys(keyMap);
        keys.sort();
        let fileName = config.profile;
        if (config.preFilterName) fileName += "_" + config.preFilterName;
        fileName += ".xlsx";
        let module = await (parcelRequire("idIeD"));
        let Excel = module.default;
        Excel.export(data, keys, fileName);
    }
    function generateDatePicker(input, value, allowEmpty, onChange) {
        const datepicker = new NativeDatepicker({
            initialValue: (0, $4ef65c8b9751a142$export$f35be9d42a770276)(value),
            onChange: (newValue)=>{
                input.value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(newValue);
                input.onchange();
            }
        });
        input.onchange = (event)=>{
            input.classList.remove("error");
            let d = new Date(input.value);
            if (isNaN(d.getTime())) {
                if (input.value || !allowEmpty) input.classList.add("error");
            } else {
                input.value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(d);
                datepicker.setValue((0, $4ef65c8b9751a142$export$f35be9d42a770276)(input.value));
            }
            if (onChange) onChange(input.value);
        };
        return datepicker.element;
    }
    return me;
})();
var $e34ba239425160f5$export$2e2bcd8739ae039 = $e34ba239425160f5$var$MasterDetail;



let $c1efb87e31920064$var$Users = (()=>{
    let me = {};
    me.render = async (container)=>{
        await (0, $e34ba239425160f5$export$2e2bcd8739ae039).render(container, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).users);
    };
    return me;
})();
var $c1efb87e31920064$export$2e2bcd8739ae039 = $c1efb87e31920064$var$Users;















let $20bb8f48a464ff95$var$NotificationService = (()=>{
    let me = {};
    me.send = async (type, recipient, data)=>{
        let result = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).sendNotification(type, recipient, data);
        console.error("Sending notification", result);
    };
    me.assign = "assign";
    me.reject = "reject";
    me.close = "close";
    return me;
})();
var $20bb8f48a464ff95$export$2e2bcd8739ae039 = $20bb8f48a464ff95$var$NotificationService;


let $5500d88e5242503c$var$IncidentService = (()=>{
    let me = {};
    me.getComments = async function(data) {
        let comments = [];
        for(let i = 1; i <= 10; i++){
            let comment = data["platform_comment_" + i];
            if (comment) {
                let c = {};
                let p = comment.indexOf(" added ");
                if (p >= 0) {
                    c.user = comment.substring(0, p);
                    comment = comment.substring(p + 7);
                }
                p = comment.lastIndexOf(" at ");
                if (p >= 0) {
                    c.date = comment.substring(p + 4);
                    comment = comment.substring(0, p);
                    let d = new Date(c.date);
                    if (isDateValid(d)) {
                        c.date = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(d);
                        c.dateTime = d.getTime();
                    }
                }
                c.comment = comment;
                comments.push(c);
            }
        }
        let k_Comments = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("comments", {
            incident: data.report_id || data.id
        });
        k_Comments.forEach((comment)=>{
            if (!comment.dateTime) comment.dateTime = comment.date;
            if (typeof comment.date === "number") comment.date = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(comment.date);
            if (comment.user && comment.user.length > 8) {
                let user = (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolve("users", comment.user);
                if (user) comment.user = user.fullname;
            }
            comments.push(comment);
        });
        comments.sort((a, b)=>a.dateTime > b.dateTime ? -1 : 1);
        return comments;
    };
    me.postComment = (comment, incident, isAuto)=>{
        return new Promise((next)=>{
            let data = {
                comment: comment,
                incident: incident.report_id || incident.id,
                user: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
                date: new Date().getTime(),
                language: (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage()
            };
            if (!isAuto) (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("comment", incident.report_id || incident.id);
            (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("comments", data).then(next);
        });
    };
    me.getActions = async function(data) {
        let actions = [];
        let k = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("actions", {
            incident: data.report_id || data.id
        });
        k.forEach((action)=>{
            if (typeof action.date === "number") action.date = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(action.date);
            if (action.user && action.user.length > 8) {
                let user = (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolve("users", action.user);
                if (user) action.user = user.fullname;
            }
            actions.push(action);
        });
        actions.sort((a, b)=>a.date > b.date ? -1 : 1);
        return actions;
    };
    me.postAction = (action, incident)=>{
        return new Promise((next)=>{
            let data = action;
            data.incident = incident.report_id || incident.id;
            data.user = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId();
            data.created = new Date().getTime();
            data.language = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
            data.id = action.id;
            (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("action", data.incident);
            (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("actions", data).then(next);
        });
    };
    me.deleteAction = (action)=>{
        return new Promise((next)=>{
            (0, $1405dab32d7e0174$export$2e2bcd8739ae039).delete("actions", action.id).then(next);
        });
    };
    me.assignToCSO = async (incident, organisation)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            assigned: organisation,
            assignedBy: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            assignedOn: new Date().getTime(),
            accepted: false,
            archived: false,
            closed: false,
            status: "Assign\xe9"
        };
        let result = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        let orgName = (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resolve("organisations", organisation).name;
        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).clearCache("incidents_assigned");
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assignedTo + " " + orgName, incident, true);
        await (0, $20bb8f48a464ff95$export$2e2bcd8739ae039).send((0, $20bb8f48a464ff95$export$2e2bcd8739ae039).assign, organisation, data);
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("assign", incidentID, organisation);
        return result;
    };
    me.archive = async (incident, status, reason)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            archived: !!status,
            archivedBy: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            archivedOn: new Date().getTime(),
            archivedReason: reason,
            status: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived
        };
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived + ": " + reason, incident, true);
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("archive", incidentID);
    };
    me.reject = async (incident, reason)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            assigned: false,
            wasAssigned: incident.assigned,
            rejected: true,
            accepted: false,
            closed: false,
            rejectedBy: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            rejectedOn: new Date().getTime(),
            rejectReason: reason,
            status: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).rejected
        };
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).rejected + ": " + reason, incident, true);
        let assignedByUser = incident.assignedBy;
        if (assignedByUser) {
            let _user = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("users", assignedByUser);
            if (_user) {
                data.description = incident.description;
                let organisation = _user.organisation;
                await (0, $20bb8f48a464ff95$export$2e2bcd8739ae039).send((0, $20bb8f48a464ff95$export$2e2bcd8739ae039).reject, organisation, data);
            }
        }
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("reject", incidentID);
    };
    me.accept = async (incident)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            accepted: true,
            acceptedBy: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            acceptedOn: new Date().getTime(),
            rejected: false,
            closed: false,
            status: "En cours de suivi",
            category: "",
            subcategory: ""
        };
        //console.log(data);
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).accepted, incident, true);
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("accept", incidentID);
    };
    me.close = async (incident, status)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            closed: true,
            closedBy: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            closedOn: new Date().getTime(),
            status: status
        };
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).closed, incident, true);
        let assignedByUser = incident.assignedBy;
        if (assignedByUser) {
            data.description = incident.description;
            data.assigned = incident.assigned;
            let _user = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("users", assignedByUser);
            if (_user) {
                let organisation = _user.organisation;
                await (0, $20bb8f48a464ff95$export$2e2bcd8739ae039).send((0, $20bb8f48a464ff95$export$2e2bcd8739ae039).close, organisation, data);
            }
        }
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("close", incidentID);
    };
    me.reopen = async (incident)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            closed: false,
            archived: false,
            closedBy: "",
            closedOn: "",
            status: "En cours de suivi"
        };
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reopened, incident, true);
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("reopen", incidentID);
    };
    me.delete = async (incident, reason)=>{
        let incidentID = incident.report_id || incident.id;
        let data = {
            id: incident.info_id,
            incident: incidentID,
            archived: true,
            archivedBy: (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserId(),
            archivedOn: new Date().getTime()
        };
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("incidents_info", data);
        //await api.delete("incidents",incidentID);
        await me.postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived + ": " + reason, incident, true);
        (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("archive", incidentID);
    };
    me.mergeInfoWithOriginal = async (incident)=>{
        if (incident.id && typeof incident.id === "string" && incident.id.indexOf("-") > 0) await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("incidents", incident.id).then((result)=>{
            if (result) {
                let newKeys = Object.keys(result);
                let oldKeys = Object.keys(incident);
                newKeys.forEach((key)=>{
                    if (!oldKeys.includes(key)) incident[key] = result[key];
                });
            }
        });
    };
    me.isAssigned = (incident)=>{
        return incident.status === (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigned || incident.status === "Assign\xe9" || incident.status === "Assigned";
    };
    me.isInprogress = (incident)=>{
        return incident.status === (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).followedUp || incident.status === "En cours de suivi" || incident.status === "In process of follow up";
    };
    me.isClosed = (incident)=>{
        return !!incident.closed;
    };
    me.isComplete = async (incidentInfo)=>{
        if (incidentInfo.incident && typeof incidentInfo.incident === "string" && incidentInfo.incident.indexOf("-") > 0) await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("incidents", incidentInfo.incident).then((result)=>{
            if (result) {
                let newKeys = Object.keys(result);
                let oldKeys = Object.keys(incidentInfo);
                newKeys.forEach((key)=>{
                    if (!oldKeys.includes(key)) incidentInfo[key] = result[key];
                });
            }
        });
        let requiredFields = [
            "date",
            "title",
            "description",
            "category",
            "subcategory",
            "province",
            "territoire",
            "sector",
            "group"
        ];
        if (incidentInfo.category === "Child labor") {
            requiredFields.push("childrenCount");
            requiredFields.push("subcategory2");
        }
        let actorCategories = [
            "Roadblock",
            "Corruption/Fraud",
            "Environmental issue",
            "Violence",
            "Theft"
        ];
        if (actorCategories.includes(incidentInfo.category)) requiredFields.push("actors");
        let complete = true;
        requiredFields.forEach((field)=>{
            if (!incidentInfo[field]) {
                console.log(field, "missing");
                complete = false;
            }
        });
        complete;
        return complete;
    };
    me.getGeoLocationFromData = (incident)=>{
        //let district = incident.district;
        //let location = dataStructure.regionLocations[district];
        //if (location) return location;
        //let region = incident.region;
        //location = dataStructure.regionLocations[region];
        //if (location) return location;
        return {
            lat: 0,
            lng: 0
        };
    };
    function isDateValid(dateStr) {
        return !isNaN(new Date(dateStr));
    }
    return me;
})();
var $5500d88e5242503c$export$2e2bcd8739ae039 = $5500d88e5242503c$var$IncidentService;













let $ab89a82b1480d34d$var$IncidentsUI = (()=>{
    let me = {};
    let labels = {
        platform_category: "Category",
        report_date: "Report Date",
        event_date: "Incident Date",
        platform_status: "Status",
        platform_status_update: "Status update",
        report_language: "Language",
        report_facility: "Province",
        report_mining: "Mining",
        report_mining_numb: "Mining number",
        report_corruption: "Corruption",
        platform_urgency: "Urgency",
        report_who: "Who",
        report_violence: "Violence",
        report_violence_who: "Violence who",
        report_violence_numb: "Violence number",
        report_victims_numb: "Victims number",
        report_environment: "Environment",
        report_environment_who: "Environment who",
        lead_organization: "Lead organization",
        report_childlabor: "Child labor",
        report_childlabor_other: "Child labor other",
        report_childlabor_numb: "Child labor number",
        report_childlabor_mining: "Child labor mining",
        report_childlabor_nonmining: "Child labor non-mining",
        report_roadblock: "Roadblock",
        report_roadblok: "Roadblock",
        report_actors: "Actors",
        report_info: "Other Information",
        report_theft: "Theft",
        report_accident: "Accident",
        report_industrial: "Industrial"
    };
    let ignoreKeys = [
        "id",
        "report_id",
        "report_informant",
        "platform_title",
        "platform_description",
        "platform_location",
        "report_location",
        "platform_location_latitude",
        "platform_location_longitude",
        "coordinates",
        "latitude",
        "longitude",
        "report_category",
        "report_describ",
        "info_id",
        "lastModified",
        "sector",
        "group",
        "miningsite",
        "isCLS",
        "description",
        "title"
    ];
    let ignorePrefix = [
        "platform_comment_"
    ];
    let translateKeys = [
        "platform_category",
        "actors",
        "category",
        "subcategory",
        "report_environment",
        "report_environment_who",
        "report_mining",
        "report_violence",
        "report_violence_who",
        "report_language",
        "report_childlabor",
        "report_childlabor_other",
        "report_actors",
        "report_roadblok",
        "report_theft",
        "report_childlabor_mining",
        "report_childlabor_nonmining",
        "report_accident",
        "report_industrial"
    ];
    let combinedKeys = [];
    let autoTranslateKeys = [];
    let resolveKeys = {
        assigned: async (value)=>{
            let item = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("organisations", value);
            return item ? item.name : "";
        }
    };
    me.renderDetail = async (item, canEdit)=>{
        let mapView, coElm;
        let data = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("incidents_external", item.report_id || item.id, true);
        if (!data || Object.keys(data).length === 0) data = item;
        let language = data.language;
        let userlanguage = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        let infoTab, infoTabContent;
        let showTabs = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentComments || (0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentActions;
        let title = data.platform_title || data.incident_title || data.title;
        let detailElm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".detail", infoTab = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tab", showTabs ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4.tabtitle", {
            onClick: ()=>{
                infoTab.classList.toggle("collapsed");
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).data_by_monitor) : undefined, infoTabContent = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tabcontent", title ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $150917cc518d921d$export$2e2bcd8739ae039).box(title, language, userlanguage)) : undefined, mapView = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("#mapView", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner")), coElm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".coordinates"))));
        mapView.innerHTML = "";
        let lat = data.latitude || data.platform_location_latitude;
        let lng = data.longitude || data.platform_location_longitude;
        lat = parseFloat(lat);
        lng = parseFloat(lng);
        if (!lat || !lng) {
            let co = (0, $5500d88e5242503c$export$2e2bcd8739ae039).getGeoLocationFromData(data);
            lat = co.lat;
            lng = co.lng;
        }
        if (lng && lat) {
            //coElm.innerHTML = lat + ", " + lng;
            //showMap(mapView,lat,lng,true,coElm);
            coElm.style.display = "none";
            mapView.style.display = "none";
        } else {
            coElm.style.display = "none";
            mapView.style.display = "none";
        }
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", {
            parent: infoTabContent
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".location", data.location || data.platform_location), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).description), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".description", (0, $150917cc518d921d$export$2e2bcd8739ae039).box(data.report_describ || data.description, language, userlanguage)), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).information), renderDataTable(data, language, userlanguage, canEdit), data.fpic && data.fpic_URL ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".files", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).image), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("a", {
            href: data.fpic_URL,
            target: "_blank"
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("img", {
            src: data.fpic_URL
        }), data.fpic)) : undefined);
        if ((0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentComments) renderCommentTab(data, detailElm);
        if (canEdit && (0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentActions) renderActionTab(data, detailElm);
        return detailElm;
    };
    function renderDataTable(data, language, userlanguage, canEdit) {
        let autoTranslate = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).autoTranslate;
        let map = {
            h1: "h1"
        };
        //console.error(data);
        let struct = (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsGenericInfo.concat((0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsInfo.fields);
        let captionCount = 0;
        struct.forEach((field)=>{
            let key = field.key;
            if (field.type === "caption") {
                captionCount++;
                key = "h" + captionCount;
                map[key] = field;
            }
            let value = data[key];
            if (value) map[key] = value;
            if (field.key === "typology") Object.keys(data).forEach((key)=>{
                if (key.startsWith("typology_")) map[key] = data[key];
            });
        });
        Object.keys(data).forEach((key)=>{
            let value = data[key];
            if (value && !map[key]) //console.error("Missing key",key);
            map[key] = value;
        });
        return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("table", Object.keys(map).map((key)=>{
            if (ignoreKeys.indexOf(key) >= 0) return;
            let ignore = false;
            ignorePrefix.forEach((prefix)=>{
                if (key.startsWith(prefix)) ignore = true;
            });
            if (ignore) return;
            let value = map[key];
            if (value && value.type === "caption") {
                let label = value.label;
                if ((0, $7cd192843b2495ee$export$2e2bcd8739ae039).stripNumbersFromIncidentCaption) {
                    label && label.indexOf(":");
                    label = label.split(":").pop().trim();
                }
                let td = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", label);
                td.setAttribute("colspan", "2");
                return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr.caption", td);
            }
            if (key === "report_date") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            if (key === "date_start") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            if (key === "date_end") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            let td = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", "" + value);
            if (resolveKeys[key]) {
                value = resolveKeys[key](value);
                if (value && value.then) value.then((value)=>{
                    td.innerText = value;
                });
                else td.innerText = value;
            }
            if (translateKeys.indexOf(key) >= 0) {
                let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(value)];
                if (translated) td.innerText = translated;
                else console.error("Missing translation for", value);
            }
            if (combinedKeys.indexOf(key) >= 0) {
                let parts = value.split(", ");
                let result = [];
                parts.forEach((part)=>{
                    let p = part.indexOf("(");
                    let other = "";
                    if (p > 0) {
                        other = part.substring(p);
                        part = part.substring(0, p).trim();
                    }
                    let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(part)];
                    if (translated) {
                        let v = translated;
                        if (other) v += " " + other;
                        result.push(v);
                    }
                });
                if (result.length) td.innerText = result.join(", ");
            }
            if (autoTranslateKeys.indexOf(key) >= 0 && autoTranslate && language !== userlanguage) {
                let t = td.innerText;
                td.innerText = "";
                td.appendChild((0, $150917cc518d921d$export$2e2bcd8739ae039).box(t, language, userlanguage));
            }
            if (typeof value === "boolean") td.innerText = value ? (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes : (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no;
            if (((0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner() || canEdit) && key === "monitor_id") {
                td.innerText = "";
                let v = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", {
                    parent: td
                }, value);
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span.infodot", {
                    parent: td,
                    onClick: ()=>{
                        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("monitors", {
                            shortname: value
                        }).then((monitors)=>{
                            v.innerHTML = "";
                            if (monitors && monitors.length) {
                                let monitor = monitors[0];
                                v.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", value), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", monitor.name), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", monitor.phone)));
                            } else v.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", value), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).unknownMonitor)));
                        });
                    }
                }, "i");
            }
            if (value) {
                let label = labels[key] || key;
                let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[label.toLowerCase().split(" ").join("_")];
                label = translated || label;
                return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", "" + label), td);
            }
        }));
    }
    async function renderCommentTab(incident, parent) {
        let tab, form, list;
        tab = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tab", {
            parent: parent
        });
        let data = await (0, $5500d88e5242503c$export$2e2bcd8739ae039).getComments(incident);
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4.tabtitle", {
            parent: tab,
            onClick: ()=>{
                tab.classList.toggle("collapsed");
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).comments + " (" + data.length + ")"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.add.addcomment.secondary", {
            onClick: ()=>{
                tab.classList.remove("collapsed");
                form.style.display = "block";
                setTimeout(()=>{
                    let textarea = form.querySelector("textarea");
                    textarea.focus();
                    textarea.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 10);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).addComment));
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tabcontent", {
            parent: tab
        }, form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentform", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("textarea"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.green.arrow", {
            onClick: (event, button)=>{
                if (button.classList.contains("laoding")) return;
                button.classList.add("loading");
                let comment = form.querySelector("textarea").value;
                if (comment) {
                    list.innerHTML = "";
                    list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).postComment(comment, incident).then(()=>{
                        (0, $5500d88e5242503c$export$2e2bcd8739ae039).getComments(incident).then((comments)=>{
                            button.classList.remove("loading");
                            list.innerHTML = "";
                            list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderComments(comments)));
                        });
                    });
                }
                form.style.display = "none";
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).save), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: ()=>{
                form.style.display = "none";
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)), list = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentlist", renderComments(data)));
    }
    async function renderActionTab(incident, parent) {
        let tab, form, list;
        tab = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tab", {
            parent: parent
        });
        let data = await (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident);
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4.tabtitle", {
            parent: tab,
            onClick: ()=>{
                tab.classList.toggle("collapsed");
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actions + " (" + data.length + ")"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.add.addcomment.secondary", {
            onClick: ()=>{
                tab.classList.remove("collapsed");
                form.style.display = "block";
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).addAction));
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tabcontent", {
            parent: tab
        }, form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentform", (0, $e34ba239425160f5$export$2e2bcd8739ae039).generateForm((0, $27ed2bfcca54492f$export$2e2bcd8739ae039).actions, (obj)=>{
            return new Promise((next)=>{
                form.style.display = "none";
                list.innerHTML = "";
                list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).postAction(obj, incident).then(()=>{
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident).then((actions)=>{
                        next();
                        list.innerHTML = "";
                        list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderActions(actions, incident, list)));
                    });
                });
            });
        }, ()=>{
            form.style.display = "none";
        })), list = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentlist", renderActions(data, incident, list)));
        return tab;
    }
    function renderComments(comments) {
        if (comments.length === 0) return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("small", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).noComments);
        let userlanguage = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        return comments.map((comment)=>{
            let lan = comment.language || "en";
            let tcomment = lan === userlanguage ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".comment", comment.comment) : (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".comment", (0, $150917cc518d921d$export$2e2bcd8739ae039).box(comment.comment, lan, userlanguage));
            return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".author", comment.user), tcomment, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".date", comment.date));
        });
    }
    function renderActions(actions, incident, list) {
        if (actions.length === 0) return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("small", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).noActions);
        let config = (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).actions;
        let userlanguage = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        if (list) {
            let tab = list.closest(".tab");
            if (tab) {
                let title = tab.querySelector(".tabtitle span");
                if (title) title.innerText = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actions + " (" + actions.length + ")";
            }
        }
        return actions.map((action)=>{
            let box = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionbox");
            renderAction(action, box, config, userlanguage, incident);
            return box;
        });
    }
    function renderAction(action, box, config, userlanguage, incident) {
        box.innerHTML = "";
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inner", {
            parent: box
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".author", action.user), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".action", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("table", config.fields.filter((a)=>a.isPrimary).map((field)=>{
            let value = action[field.key];
            if (field.values) {
                if (field.type === "multiselect") value = value.split(", ").map((val)=>{
                    let v = field.values.find((v)=>v.value === val);
                    if (v) return v.label;
                    return value;
                }).join(", ");
                else {
                    let v = field.values.find((v)=>v.value === value);
                    if (v) value = v.label;
                }
            }
            if (field.translateContent) {
                let lan = action.language || "en";
                if (lan !== userlanguage) value = (0, $150917cc518d921d$export$2e2bcd8739ae039).box(value, lan, userlanguage);
            }
            return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", field.label), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", value));
        }))), (0, $dad842a3fb977628$export$2e2bcd8739ae039).isAdmin() && (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.edit.float.tertiary", {
            onClick: ()=>{
                editAction(action, box, config, userlanguage, incident);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).edit), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".date", action.date));
    }
    function editAction(action, box, config, userlanguage, incident) {
        box.innerHTML = "";
        let form = (0, $e34ba239425160f5$export$2e2bcd8739ae039).generateForm((0, $27ed2bfcca54492f$export$2e2bcd8739ae039).actions, (obj)=>{
            return new Promise((next)=>{
                form.style.display = "none";
                let list = box.closest(".commentlist");
                list.innerHTML = "";
                obj.id = action.id;
                list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).postAction(obj, incident).then(()=>{
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident).then((actions)=>{
                        next();
                        list.innerHTML = "";
                        list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderActions(actions, incident, list)));
                    });
                });
            });
        }, ()=>{
            renderAction(action, box, config, userlanguage);
        }, ()=>{
            (0, $5500d88e5242503c$export$2e2bcd8739ae039).deleteAction(action).then(()=>{
                let list = box.closest(".commentlist");
                list.innerHTML = "";
                list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident).then((actions)=>{
                    list.innerHTML = "";
                    list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderActions(actions, incident, list)));
                });
            });
        }, action);
        box.appendChild(form);
    }
    function showMap(parent, lat, lng, dragMarker, coElm) {
        mapboxgl.accessToken = "pk.eyJ1IjoiaXBpc3Jlc2VhcmNoIiwiYSI6IklBazVQTWcifQ.K13FKWN_xlKPJFj9XjkmbQ";
        const map = new mapboxgl.Map({
            container: parent,
            style: "mapbox://styles/mapbox/streets-v12",
            center: [
                lng,
                lat
            ],
            zoom: 9 // starting zoom
        });
        const marker = new mapboxgl.Marker({
            draggable: dragMarker
        }).setLngLat([
            lng,
            lat
        ]).addTo(map);
        marker.on("dragend", ()=>{
            const co = marker.getLngLat();
            coElm.innerHTML = co.lat.toFixed(7) + ", " + co.lng.toFixed(7);
        //coordinates.style.display = 'block';
        //coordinates.innerHTML = `Longitude: ${lngLat.lng}<br />Latitude: ${lngLat.lat}`;
        });
    }
    return me;
})();
var $ab89a82b1480d34d$export$2e2bcd8739ae039 = $ab89a82b1480d34d$var$IncidentsUI;


let $f80621448b29dfb8$var$IncidentsSms = (()=>{
    let me = {};
    me.render = async (container, params, id)=>{
        let config = Object.assign({}, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsSMS);
        config.openDetailId = id;
        if (params && params.filter) {
            config.preFilterName = params.filter;
            if (params.filter === "assigned") config.preFilter = (item)=>!!item.assigned && !item.archived;
            if (params.filter === "nonassigned") {
                config.preFilter = (item)=>!item.assigned && !item.archived;
                config.buttons = [
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).fetchExternal,
                        onClick: async (event, button)=>{
                            if (button.classList.contains("loading")) return;
                            button.classList.add("loading");
                            await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).get("ulula");
                            setTimeout(()=>{
                                button.classList.remove("loading");
                                document.location.reload();
                            }, 1000);
                        }
                    }
                ];
            }
            if (params.filter === "archived") config.preFilter = (item)=>!!item.archived;
        }
        config.detail = async (item, formContainer)=>{
            window.location.hash = "incidents-sms/" + item.report_id;
            formContainer.innerHTML = "<h3>Incident</h3>";
            formContainer.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".closebutton.light", {
                onClick: (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel
            }));
            console.log("Incident", item);
            formContainer.appendChild(await (0, $ab89a82b1480d34d$export$2e2bcd8739ae039).renderDetail(item), false);
            let actionPanel = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".incidentactions", {
                parent: formContainer
            }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".slidepanel"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttonsbar", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green.arrow", {
                onClick: ()=>{
                    showAssignForm(actionPanel, item);
                }
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigntoCSO), !item.archived && (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red.delete", {
                onClick: ()=>{
                    showArchiveForm(actionPanel, item);
                }
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archive), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.blue.arrow", {
                onClick: ()=>{
                    (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                }
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        };
        // preload organisations
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("organisations");
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("users");
        await (0, $e34ba239425160f5$export$2e2bcd8739ae039).render(container, config);
    };
    function showArchiveForm(parent, item) {
        let slidePanel = parent.querySelector(".slidepanel");
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionform", {
            parent: slidePanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archive), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".content", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archiveReason), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("textarea", {
            placeholder: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archiveReasonExample
        })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.blue.arrow", {
            onClick: (e)=>{
                let button = e.target.closest("button");
                if (button) {
                    if (button.classList.contains("loading")) return;
                    button.classList.add("loading");
                }
                let textarea = form.querySelector("textarea");
                let reason = textarea.value;
                if (reason) {
                    let from = "nonassigned";
                    if (item.assigned) from = "assigned";
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).archive(item, true, reason).then(()=>{
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                        if (button) button.classList.remove("loading");
                        closeForm();
                        (0, $11c795e9343571a1$export$2e2bcd8739ae039).animateUpdate(from, "archived", 1);
                    });
                } else {
                    if (button) button.classList.remove("loading");
                    textarea.classList.remove("error");
                    setTimeout(()=>{
                        textarea.classList.add("error");
                    }, 10);
                }
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archive), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: closeForm
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        parent.classList.add("active");
        setTimeout(()=>{
            form.classList.add("active");
        }, 10);
        function closeForm() {
            form.classList.remove("active");
            setTimeout(()=>{
                parent.classList.remove("active");
                slidePanel.removeChild(form);
            }, 300);
        }
    }
    async function showAssignForm(parent, item) {
        let slidePanel = parent.querySelector(".slidepanel");
        let selectPanel;
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionform", {
            parent: slidePanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigntoCSO), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".content", item.assigned ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".warningbox", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).alreadyAssigned) : undefined, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assignIntro + " " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assignEmail), selectPanel = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner")), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.blue.arrow", {
            onClick: (e)=>{
                let button = e.target.closest("button");
                if (button) {
                    if (button.classList.contains("loading")) return;
                    button.classList.add("loading");
                }
                let select = selectPanel.querySelector("select");
                let organisation = select.value;
                if (organisation) {
                    let from = "nonassigned";
                    if (item.assigned) from = "assigned";
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).assignToCSO(item, organisation).then(()=>{
                        if (button) button.classList.remove("loading");
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                        closeForm();
                        (0, $11c795e9343571a1$export$2e2bcd8739ae039).animateUpdate(from, "assigned", 1);
                    });
                } else {
                    if (button) button.classList.remove("loading");
                    select.classList.remove("error");
                    setTimeout(()=>{
                        select.classList.add("error");
                    }, 10);
                }
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assigntoCSO), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: closeForm
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        parent.classList.add("active");
        setTimeout(()=>{
            form.classList.add("active");
        }, 10);
        function closeForm() {
            form.classList.remove("active");
            setTimeout(()=>{
                parent.classList.remove("active");
                slidePanel.removeChild(form);
            }, 300);
        }
        let list = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).distinct("organisations", "name");
        selectPanel.innerHTML = "";
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("select", {
            parent: selectPanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
            value: ""
        }, "--- " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).pleaseSelect), list.map((item)=>(0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
                value: item.id
            }, item.name)));
    }
    return me;
})();
var $f80621448b29dfb8$export$2e2bcd8739ae039 = $f80621448b29dfb8$var$IncidentsSms;






















let $18b0a99237e3045a$var$IncidentsUI = (()=>{
    let me = {};
    let labels = {
        platform_category: "Category",
        report_date: "Report Date",
        event_date: "Incident Date",
        platform_status: "Status",
        platform_status_update: "Status update",
        report_language: "Language",
        report_facility: "Province",
        report_mining: "Mining",
        report_mining_numb: "Mining number",
        report_corruption: "Corruption",
        platform_urgency: "Urgency",
        report_who: "Who",
        report_violence: "Violence",
        report_violence_who: "Violence who",
        report_violence_numb: "Violence number",
        report_victims_numb: "Victims number",
        report_environment: "Environment",
        report_environment_who: "Environment who",
        lead_organization: "Lead organization",
        report_childlabor: "Child labor",
        report_childlabor_other: "Child labor other",
        report_childlabor_numb: "Child labor number",
        report_childlabor_mining: "Child labor mining",
        report_childlabor_nonmining: "Child labor non-mining",
        report_roadblock: "Roadblock",
        report_roadblok: "Roadblock",
        report_actors: "Actors",
        report_info: "Other Information",
        report_theft: "Theft",
        report_accident: "Accident",
        report_industrial: "Industrial"
    };
    let ignoreKeys = [
        "id",
        "report_id",
        "report_informant",
        "platform_title",
        "platform_description",
        "platform_location",
        "report_location",
        "platform_location_latitude",
        "platform_location_longitude",
        "coordinates",
        "latitude",
        "longitude",
        "report_category",
        "report_describ",
        "info_id",
        "lastModified",
        "sector",
        "group",
        "miningsite",
        "isCLS",
        "description",
        "title"
    ];
    let ignorePrefix = [
        "platform_comment_"
    ];
    let translateKeys = [
        "platform_category",
        "actors",
        "category",
        "subcategory",
        "report_environment",
        "report_environment_who",
        "report_mining",
        "report_violence",
        "report_violence_who",
        "report_language",
        "report_childlabor",
        "report_childlabor_other",
        "report_actors",
        "report_roadblok",
        "report_theft",
        "report_childlabor_mining",
        "report_childlabor_nonmining",
        "report_accident",
        "report_industrial"
    ];
    let combinedKeys = [];
    let autoTranslateKeys = [];
    let resolveKeys = {
        assigned: async (value)=>{
            let item = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("organisations", value);
            return item ? item.name : "";
        }
    };
    me.renderDetail = async (item, canEdit)=>{
        let mapView, coElm;
        let data = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("incidents_external", item.report_id || item.id, true);
        if (!data || Object.keys(data).length === 0) data = item;
        let language = data.language;
        let userlanguage = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        let infoTab, infoTabContent;
        let showTabs = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentComments || (0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentActions;
        let title = data.platform_title || data.incident_title || data.title;
        let detailElm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".detail", infoTab = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tab", showTabs ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4.tabtitle", {
            onClick: ()=>{
                infoTab.classList.toggle("collapsed");
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).data_by_monitor) : undefined, infoTabContent = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tabcontent", title ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $150917cc518d921d$export$2e2bcd8739ae039).box(title, language, userlanguage)) : undefined, mapView = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("#mapView", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner")), coElm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".coordinates"))));
        mapView.innerHTML = "";
        let lat = data.latitude || data.platform_location_latitude;
        let lng = data.longitude || data.platform_location_longitude;
        lat = parseFloat(lat);
        lng = parseFloat(lng);
        if (!lat || !lng) {
            let co = (0, $5500d88e5242503c$export$2e2bcd8739ae039).getGeoLocationFromData(data);
            lat = co.lat;
            lng = co.lng;
        }
        if (lng && lat) {
            //coElm.innerHTML = lat + ", " + lng;
            //showMap(mapView,lat,lng,true,coElm);
            coElm.style.display = "none";
            mapView.style.display = "none";
        } else {
            coElm.style.display = "none";
            mapView.style.display = "none";
        }
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", {
            parent: infoTabContent
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".location", data.location || data.platform_location), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).description), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".description", (0, $150917cc518d921d$export$2e2bcd8739ae039).box(data.report_describ || data.description, language, userlanguage)), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).information), renderDataTable(data, language, userlanguage, canEdit), data.fpic && data.fpic_URL ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".files", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).image), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("a", {
            href: data.fpic_URL,
            target: "_blank"
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("img", {
            src: data.fpic_URL
        }), data.fpic)) : undefined);
        if ((0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentComments) renderCommentTab(data, detailElm);
        if (canEdit && (0, $7cd192843b2495ee$export$2e2bcd8739ae039).useIncidentActions) renderActionTab(data, detailElm);
        return detailElm;
    };
    function renderDataTable(data, language, userlanguage, canEdit) {
        let autoTranslate = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).autoTranslate;
        let map = {
            h1: "h1"
        };
        //console.error(data);
        let struct = (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsGenericInfo.concat((0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsInfo.fields);
        let captionCount = 0;
        struct.forEach((field)=>{
            let key = field.key;
            if (field.type === "caption") {
                captionCount++;
                key = "h" + captionCount;
                map[key] = field;
            }
            let value = data[key];
            if (value) map[key] = value;
            if (field.key === "typology") Object.keys(data).forEach((key)=>{
                if (key.startsWith("typology_")) map[key] = data[key];
            });
        });
        Object.keys(data).forEach((key)=>{
            let value = data[key];
            if (value && !map[key]) //console.error("Missing key",key);
            map[key] = value;
        });
        return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("table", Object.keys(map).map((key)=>{
            if (ignoreKeys.indexOf(key) >= 0) return;
            let ignore = false;
            ignorePrefix.forEach((prefix)=>{
                if (key.startsWith(prefix)) ignore = true;
            });
            if (ignore) return;
            let value = map[key];
            if (value && value.type === "caption") {
                let label = value.label;
                if ((0, $7cd192843b2495ee$export$2e2bcd8739ae039).stripNumbersFromIncidentCaption) {
                    label && label.indexOf(":");
                    label = label.split(":").pop().trim();
                }
                let td = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", label);
                td.setAttribute("colspan", "2");
                return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr.caption", td);
            }
            if (key === "report_date") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            if (key === "date_start") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            if (key === "date_end") value = (0, $4ef65c8b9751a142$export$3ae94a2503e890a1)(value);
            let td = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", "" + value);
            if (resolveKeys[key]) {
                value = resolveKeys[key](value);
                if (value && value.then) value.then((value)=>{
                    td.innerText = value;
                });
                else td.innerText = value;
            }
            if (translateKeys.indexOf(key) >= 0) {
                let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(value)];
                if (translated) td.innerText = translated;
                else console.error("Missing translation for", value);
            }
            if (combinedKeys.indexOf(key) >= 0) {
                let parts = value.split(", ");
                let result = [];
                parts.forEach((part)=>{
                    let p = part.indexOf("(");
                    let other = "";
                    if (p > 0) {
                        other = part.substring(p);
                        part = part.substring(0, p).trim();
                    }
                    let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[(0, $4ef65c8b9751a142$export$cb0bbc88c7f09596)(part)];
                    if (translated) {
                        let v = translated;
                        if (other) v += " " + other;
                        result.push(v);
                    }
                });
                if (result.length) td.innerText = result.join(", ");
            }
            if (autoTranslateKeys.indexOf(key) >= 0 && autoTranslate && language !== userlanguage) {
                let t = td.innerText;
                td.innerText = "";
                td.appendChild((0, $150917cc518d921d$export$2e2bcd8739ae039).box(t, language, userlanguage));
            }
            if (typeof value === "boolean") td.innerText = value ? (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).yes : (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).no;
            if (((0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner() || canEdit) && key === "monitor_id") {
                td.innerText = "";
                let v = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", {
                    parent: td
                }, value);
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span.infodot", {
                    parent: td,
                    onClick: ()=>{
                        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("monitors", {
                            shortname: value
                        }).then((monitors)=>{
                            v.innerHTML = "";
                            if (monitors && monitors.length) {
                                let monitor = monitors[0];
                                v.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", value), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", monitor.name), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", monitor.phone)));
                            } else v.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", value), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).unknownMonitor)));
                        });
                    }
                }, "i");
            }
            if (value) {
                let label = labels[key] || key;
                let translated = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[label.toLowerCase().split(" ").join("_")];
                label = translated || label;
                return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", "" + label), td);
            }
        }));
    }
    async function renderCommentTab(incident, parent) {
        let tab, form, list;
        tab = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tab", {
            parent: parent
        });
        let data = await (0, $5500d88e5242503c$export$2e2bcd8739ae039).getComments(incident);
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4.tabtitle", {
            parent: tab,
            onClick: ()=>{
                tab.classList.toggle("collapsed");
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).comments + " (" + data.length + ")"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.add.addcomment.secondary", {
            onClick: ()=>{
                tab.classList.remove("collapsed");
                form.style.display = "block";
                setTimeout(()=>{
                    let textarea = form.querySelector("textarea");
                    textarea.focus();
                    textarea.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 10);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).addComment));
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tabcontent", {
            parent: tab
        }, form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentform", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("textarea"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.green.arrow", {
            onClick: (event, button)=>{
                if (button.classList.contains("laoding")) return;
                button.classList.add("loading");
                let comment = form.querySelector("textarea").value;
                if (comment) {
                    list.innerHTML = "";
                    list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).postComment(comment, incident).then(()=>{
                        (0, $5500d88e5242503c$export$2e2bcd8739ae039).getComments(incident).then((comments)=>{
                            button.classList.remove("loading");
                            list.innerHTML = "";
                            list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderComments(comments)));
                        });
                    });
                }
                form.style.display = "none";
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).save), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: ()=>{
                form.style.display = "none";
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)), list = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentlist", renderComments(data)));
    }
    async function renderActionTab(incident, parent) {
        let tab, form, list;
        tab = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tab", {
            parent: parent
        });
        let data = await (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident);
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h4.tabtitle", {
            parent: tab,
            onClick: ()=>{
                tab.classList.toggle("collapsed");
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actions + " (" + data.length + ")"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.add.addcomment.secondary", {
            onClick: ()=>{
                tab.classList.remove("collapsed");
                form.style.display = "block";
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).addAction));
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".tabcontent", {
            parent: tab
        }, form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentform", (0, $e34ba239425160f5$export$2e2bcd8739ae039).generateForm((0, $27ed2bfcca54492f$export$2e2bcd8739ae039).actions, (obj)=>{
            return new Promise((next)=>{
                form.style.display = "none";
                list.innerHTML = "";
                list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).postAction(obj, incident).then(()=>{
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident).then((actions)=>{
                        next();
                        list.innerHTML = "";
                        list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderActions(actions, incident, list)));
                    });
                });
            });
        }, ()=>{
            form.style.display = "none";
        })), list = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentlist", renderActions(data, incident, list)));
        return tab;
    }
    function renderComments(comments) {
        if (comments.length === 0) return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("small", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).noComments);
        let userlanguage = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        return comments.map((comment)=>{
            let lan = comment.language || "en";
            let tcomment = lan === userlanguage ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".comment", comment.comment) : (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".comment", (0, $150917cc518d921d$export$2e2bcd8739ae039).box(comment.comment, lan, userlanguage));
            return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".commentbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".author", comment.user), tcomment, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".date", comment.date));
        });
    }
    function renderActions(actions, incident, list) {
        if (actions.length === 0) return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("small", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).noActions);
        let config = (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).actions;
        let userlanguage = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        if (list) {
            let tab = list.closest(".tab");
            if (tab) {
                let title = tab.querySelector(".tabtitle span");
                if (title) title.innerText = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).actions + " (" + actions.length + ")";
            }
        }
        return actions.map((action)=>{
            let box = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionbox");
            renderAction(action, box, config, userlanguage, incident);
            return box;
        });
    }
    function renderAction(action, box, config, userlanguage, incident) {
        box.innerHTML = "";
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inner", {
            parent: box
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".author", action.user), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".action", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("table", config.fields.filter((a)=>a.isPrimary).map((field)=>{
            let value = action[field.key];
            if (field.values) {
                if (field.type === "multiselect") value = value.split(", ").map((val)=>{
                    let v = field.values.find((v)=>v.value === val);
                    if (v) return v.label;
                    return value;
                }).join(", ");
                else {
                    let v = field.values.find((v)=>v.value === value);
                    if (v) value = v.label;
                }
            }
            if (field.translateContent) {
                let lan = action.language || "en";
                if (lan !== userlanguage) value = (0, $150917cc518d921d$export$2e2bcd8739ae039).box(value, lan, userlanguage);
            }
            return (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("tr", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", field.label), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("td", value));
        }))), (0, $dad842a3fb977628$export$2e2bcd8739ae039).isAdmin() && (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.edit.float.tertiary", {
            onClick: ()=>{
                editAction(action, box, config, userlanguage, incident);
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).edit), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".date", action.date));
    }
    function editAction(action, box, config, userlanguage, incident) {
        box.innerHTML = "";
        let form = (0, $e34ba239425160f5$export$2e2bcd8739ae039).generateForm((0, $27ed2bfcca54492f$export$2e2bcd8739ae039).actions, (obj)=>{
            return new Promise((next)=>{
                form.style.display = "none";
                let list = box.closest(".commentlist");
                list.innerHTML = "";
                obj.id = action.id;
                list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).postAction(obj, incident).then(()=>{
                    (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident).then((actions)=>{
                        next();
                        list.innerHTML = "";
                        list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderActions(actions, incident, list)));
                    });
                });
            });
        }, ()=>{
            renderAction(action, box, config, userlanguage);
        }, ()=>{
            (0, $5500d88e5242503c$export$2e2bcd8739ae039).deleteAction(action).then(()=>{
                let list = box.closest(".commentlist");
                list.innerHTML = "";
                list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"));
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).getActions(incident).then((actions)=>{
                    list.innerHTML = "";
                    list.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", renderActions(actions, incident, list)));
                });
            });
        }, action);
        box.appendChild(form);
    }
    function showMap(parent, lat, lng, dragMarker, coElm) {
        mapboxgl.accessToken = "pk.eyJ1IjoiaXBpc3Jlc2VhcmNoIiwiYSI6IklBazVQTWcifQ.K13FKWN_xlKPJFj9XjkmbQ";
        const map = new mapboxgl.Map({
            container: parent,
            style: "mapbox://styles/mapbox/streets-v12",
            center: [
                lng,
                lat
            ],
            zoom: 9 // starting zoom
        });
        const marker = new mapboxgl.Marker({
            draggable: dragMarker
        }).setLngLat([
            lng,
            lat
        ]).addTo(map);
        marker.on("dragend", ()=>{
            const co = marker.getLngLat();
            coElm.innerHTML = co.lat.toFixed(7) + ", " + co.lng.toFixed(7);
        //coordinates.style.display = 'block';
        //coordinates.innerHTML = `Longitude: ${lngLat.lng}<br />Latitude: ${lngLat.lat}`;
        });
    }
    return me;
})();
var $18b0a99237e3045a$export$2e2bcd8739ae039 = $18b0a99237e3045a$var$IncidentsUI;


let $9b28866441da4ff1$var$IncidentsAssigned = (()=>{
    let me = {};
    me.render = async (container, params, id)=>{
        let config = Object.assign({}, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsAssigned);
        config.openDetailId = id;
        let userData = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getCurrentUser();
        let orgId = userData ? userData.organisation : "";
        if (params && params.filter) {
            config.preFilterName = params.filter;
            if (params.filter === "open") config.preFilter = (item)=>item.accepted && item.assigned && !item.closed && !item.archived;
            if (params.filter === "closed") config.preFilter = (item)=>item.closed && !item.archived;
            if (params.filter === "pending") config.preFilter = (item)=>!item.accepted && !item.archived;
            if (params.filter === "new") config.preFilter = (item)=>!item.accepted && item.assigned === orgId && !item.archived;
            if (params.filter === "working") config.preFilter = (item)=>item.accepted && item.assigned === orgId && !item.closed && !item.archived;
            if (params.filter === "complete") config.preFilter = (item)=>item.accepted && item.assigned === orgId && item.closed && !item.archived;
            if (params.filter === "myarchived") config.preFilter = (item)=>!!item.archived && item.assigned === orgId;
            if (params.filter === "allarchived") config.preFilter = (item)=>!!item.archived;
        }
        config.detail = async (item, formContainer)=>{
            window.location.hash = "incidents-cso/" + (item.report_id || item.id);
            formContainer.innerHTML = "<h3>Incident</h3>";
            formContainer.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".closebutton.light", {
                onClick: (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel
            }));
            let reportData = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getIncident(item.report_id || item.id);
            let userData = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getCurrentUser();
            let incidentInfo = item;
            if (item.info_id) {
                incidentInfo = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getById("incidents_info", item.info_id, true);
                if (!incidentInfo.status) incidentInfo.status = item.status;
            }
            let isMine = userData.organisation === reportData.assigned;
            let canEdit = isMine || (0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner();
            formContainer.appendChild(await (0, $18b0a99237e3045a$export$2e2bcd8739ae039).renderDetail(reportData, canEdit));
            if (canEdit) {
                let actionPanel = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".incidentactions", {
                    parent: formContainer
                }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".slidepanel"));
                if ((0, $5500d88e5242503c$export$2e2bcd8739ae039).isAssigned(incidentInfo)) {
                    actionPanel.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttonsbar", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green.arrow", {
                        onClick: (event, button)=>{
                            if (button.classList.contains("loading")) return;
                            button.classList.add("loading");
                            (0, $5500d88e5242503c$export$2e2bcd8739ae039).accept(item).then(()=>{
                                button.classList.remove("loading");
                                (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                                (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                                (0, $11c795e9343571a1$export$2e2bcd8739ae039).animateUpdate("new", "working", 1);
                            });
                        }
                    }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).accept), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red.delete", {
                        onClick: ()=>{
                            showRejectForm(actionPanel, item);
                        }
                    }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reject), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.blue.arrow", {
                        onClick: ()=>{
                            (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                        }
                    }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).close)));
                    let dConfig = Object.assign({}, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsInfo);
                    if ((0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner()) (0, $e34ba239425160f5$export$2e2bcd8739ae039).double(dConfig);
                } else if (!(0, $5500d88e5242503c$export$2e2bcd8739ae039).isClosed(incidentInfo)) {
                    let dConfig = Object.assign({}, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsInfo);
                    let isComplete = await (0, $5500d88e5242503c$export$2e2bcd8739ae039).isComplete(incidentInfo);
                    if (isComplete) dConfig.additionalButtons = ()=>{
                        return [
                            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("hr"),
                            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.blue.check", {
                                onClick: ()=>{
                                    showCompleteForm(actionPanel, item);
                                }
                            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mark_as_completed)
                        ];
                    };
                    else dConfig.additionalButtons = ()=>{
                        return [
                            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("hr"),
                            (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.blue.check.disabled", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mark_as_completed, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".hovermessage", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).complete_data_first))
                        ];
                    };
                    (0, $e34ba239425160f5$export$2e2bcd8739ae039).double(dConfig);
                } else {
                    let buttons = [
                        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green.arrow", {
                            onClick: ()=>{
                                showReOpenForm(actionPanel, item);
                            }
                        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reopen)
                    ];
                    if ((0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner() && !item.archived) buttons.push((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.red.delete", {
                        onClick: ()=>{
                            showDeleteForm(actionPanel, item);
                        }
                    }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archive));
                    buttons.push((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.blue.arrow", {
                        onClick: ()=>{
                            (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                        }
                    }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).close));
                    actionPanel.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttonsbar", buttons));
                    let dConfig = Object.assign({}, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsInfo);
                    (0, $e34ba239425160f5$export$2e2bcd8739ae039).double(dConfig, !(0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner());
                }
            } else {
                //if (incidentService.isClosed(incidentInfo)){
                let dConfig = Object.assign({}, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).incidentsInfo);
                (0, $e34ba239425160f5$export$2e2bcd8739ae039).double(dConfig, true);
            //}
            }
        /*let comments = await getComments(reportData);
            mapView.innerHTML = ""

            let lat = item.latitude;
            let lng = item.longitude;
            lat = parseFloat(lat);
            lng = parseFloat(lng);

            if (lng && lat){
                coElm.innerHTML = lat + ", " + lng;
                showMap(mapView,lat,lng,true,coElm);
            }

            $("div",{parent:detailElm},
                $(".location",item.location),
                $("h4",translations.information),
                $("table",Object.keys(reportData).map(key=>{
                    if (ignoreKeys.indexOf(key)>=0) return;
                    if (key.startsWith("platform_comment_")) return;
                    let value = reportData[key];
                    if (key==="report_date") value = formatDate(value);

                    let td = $("td",""+value);
                    if (resolveKeys[key]){
                        value = resolveKeys[key](value);
                        if (value && value.then){
                            value.then(value=>{
                                td.innerText = value;
                            });
                        }else{
                            td.innerText = value;
                        }
                    }

                    if (translateKeys.indexOf(key)>=0){
                        let translated = translations[cleanString(value)];
                        if (translated) td.innerText = translated;
                    }


                    if (value){
                        let label = labels[key] || key;
                        let translated = translations[label.toLowerCase().split(" ").join("_")];
                        label = translated || label;
                        return $("tr",$("td",""+label),td);
                    }
                }),
                    item.lastModified && $("tr",$("td",translations.lastModified),$("td",formatDate(item.lastModified)))
                ),
                $("h4",translations.description),
                $(".description",reportData.report_describ || reportData.description),
                $("h4",translations.comments),
                commentlist = $(".commentlist", renderComments(comments)),
                $("button.text.add.addcomment" + (comments.length?"":".up"),{onClick:()=>{
                        commentForm.style.display = "block";
                        setTimeout(()=>{
                            let textarea = commentForm.querySelector("textarea");
                            textarea.focus();
                            textarea.scrollIntoView({ behavior: "smooth"})
                        },10);
                    }},translations.addComment),
                commentForm = $("div.commentform",$("textarea"),
                    $("button.secondary.green.arrow",{onClick:()=>{
                            let comment = commentForm.querySelector("textarea").value;
                            if (comment){
                                commentlist.innerHTML = "";
                                commentlist.appendChild($(".spinner"));
                                incidentService.postComment(comment,item).then(()=>{
                                    getComments(reportData).then(comments=>{
                                        commentlist.innerHTML = "";
                                        commentlist.appendChild($("div",renderComments(comments)));
                                    });
                                });
                            }
                            commentForm.style.display = "none";
                        }},translations.save),
                    $("button.secondary.red.delete",{onClick:()=>{
                            commentForm.style.display = "none";
                        }},translations.cancel)
                )
            )*/ };
        config.postProcessing = async (data)=>{
        //console.error("postProcessing",data);
        };
        config.postUpdate = async (data, result, isNew)=>{
            if (isNew) {
                (0, $a979bca9e51c7bc2$export$2e2bcd8739ae039).log("create", result.id);
                await (0, $5500d88e5242503c$export$2e2bcd8739ae039).postComment((0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).created + " " + (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).incident, result, true);
            }
            //console.error("postUpdate",data,result,isNew);
            // auto assign to CSO
            let assignResult = await (0, $5500d88e5242503c$export$2e2bcd8739ae039).assignToCSO(result, (0, $dad842a3fb977628$export$2e2bcd8739ae039).getUserOrganisation());
            result.info_id = assignResult.id;
            // and auto accept
            await (0, $5500d88e5242503c$export$2e2bcd8739ae039).accept(result);
        };
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("organisations");
        await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).list("users");
        await (0, $e34ba239425160f5$export$2e2bcd8739ae039).render(container, config);
    };
    function showRejectForm(parent, item) {
        let slidePanel = parent.querySelector(".slidepanel");
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionform", {
            parent: slidePanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reject), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".content", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).rejectReason), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("textarea", {
            placeholder: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reason
        })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.blue.arrow", {
            onClick: (event, button)=>{
                if (button.classList.contains("loading")) return;
                button.classList.add("loading");
                let textarea = form.querySelector("textarea");
                let reason = textarea.value;
                if (reason) (0, $5500d88e5242503c$export$2e2bcd8739ae039).reject(item, reason).then(()=>{
                    (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                    button.classList.remove("loading");
                    closeForm();
                    setTimeout(()=>{
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                    }, 300);
                });
                else {
                    button.classList.remove("loading");
                    textarea.classList.remove("error");
                    setTimeout(()=>{
                        textarea.classList.add("error");
                    }, 10);
                }
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reject), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: closeForm
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        parent.classList.add("active");
        setTimeout(()=>{
            form.classList.add("active");
        }, 10);
        function closeForm() {
            form.classList.remove("active");
            setTimeout(()=>{
                parent.classList.remove("active");
                slidePanel.removeChild(form);
            }, 300);
        }
    }
    function showDeleteForm(parent, item) {
        let slidePanel = parent.querySelector(".slidepanel");
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionform", {
            parent: slidePanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archive), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".content", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archiveReason), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("textarea", {
            placeholder: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reason
        })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.blue.arrow", {
            onClick: (event, button)=>{
                if (button.classList.contains("loading")) return;
                button.classList.add("loading");
                let textarea = form.querySelector("textarea");
                let reason = textarea.value;
                if (reason) (0, $5500d88e5242503c$export$2e2bcd8739ae039).delete(item, reason).then(()=>{
                    (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                    button.classList.remove("loading");
                    closeForm();
                    setTimeout(()=>{
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                    }, 300);
                });
                else {
                    button.classList.remove("loading");
                    textarea.classList.remove("error");
                    setTimeout(()=>{
                        textarea.classList.add("error");
                    }, 10);
                }
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archive), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: closeForm
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        parent.classList.add("active");
        setTimeout(()=>{
            form.classList.add("active");
        }, 10);
        function closeForm() {
            form.classList.remove("active");
            setTimeout(()=>{
                parent.classList.remove("active");
                slidePanel.removeChild(form);
            }, 300);
        }
    }
    function showCompleteForm(parent, item) {
        let slidePanel = parent.querySelector(".slidepanel");
        let statusSelect, status;
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionform", {
            parent: slidePanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mark_as_completed), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".content", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).sureToComplete), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).selectCloseStatus), statusSelect = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("select", {
            onchange: ()=>{
                status = statusSelect.value;
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
            value: ""
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).pleaseSelect), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
            value: "R\xe9solu"
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).resolved), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
            value: "Non r\xe9solu"
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).notResolved), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
            value: "Persistant"
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).persistent), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("option", {
            value: "Non-Suivi"
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).notFollowedUp)), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.green.check", {
            onClick: (event, button)=>{
                if (button.classList.contains("loading")) return;
                if (!status) {
                    statusSelect.classList.remove("error");
                    setTimeout(()=>{
                        statusSelect.classList.add("error");
                    }, 10);
                    return;
                }
                button.classList.add("loading");
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).close(item, status).then(()=>{
                    button.classList.remove("loading");
                    closeForm();
                    setTimeout(()=>{
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                        (0, $11c795e9343571a1$export$2e2bcd8739ae039).animateUpdate("working", "complete", 1);
                    }, 300);
                });
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mark_as_completed), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: closeForm
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        parent.classList.add("active");
        setTimeout(()=>{
            form.classList.add("active");
        }, 10);
        function closeForm() {
            form.classList.remove("active");
            setTimeout(()=>{
                parent.classList.remove("active");
                slidePanel.removeChild(form);
            }, 300);
        }
    }
    function showReOpenForm(parent, item) {
        let slidePanel = parent.querySelector(".slidepanel");
        let statusSelect, status;
        let form = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".actionform", {
            parent: slidePanel
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h3", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).reopen), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".content", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("p", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).sureToReopen), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.green.check", {
            onClick: (event, button)=>{
                if (button.classList.contains("loading")) return;
                button.classList.add("loading");
                (0, $5500d88e5242503c$export$2e2bcd8739ae039).reopen(item, status).then(()=>{
                    button.classList.remove("loading");
                    closeForm();
                    setTimeout(()=>{
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).closeSidePanel();
                        (0, $e34ba239425160f5$export$2e2bcd8739ae039).refresh();
                        (0, $11c795e9343571a1$export$2e2bcd8739ae039).animateUpdate("complete", "working", 1);
                    }, 300);
                });
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).mark_as_open), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.secondary.red.delete", {
            onClick: closeForm
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).cancel)));
        parent.classList.add("active");
        setTimeout(()=>{
            form.classList.add("active");
        }, 10);
        function closeForm() {
            form.classList.remove("active");
            setTimeout(()=>{
                parent.classList.remove("active");
                slidePanel.removeChild(form);
            }, 300);
        }
    }
    return me;
})();
var $9b28866441da4ff1$export$2e2bcd8739ae039 = $9b28866441da4ff1$var$IncidentsAssigned;





let $605b2b6cbe61d8c6$var$Organisations = (()=>{
    let me = {};
    me.render = async (container)=>{
        await (0, $e34ba239425160f5$export$2e2bcd8739ae039).render(container, (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).organisations);
    };
    return me;
})();
var $605b2b6cbe61d8c6$export$2e2bcd8739ae039 = $605b2b6cbe61d8c6$var$Organisations;




let $3a934ee67fa09fba$var$Information = (()=>{
    let me = {};
    me.render = async (container)=>{
        let content = await fetch("_pages/information.html").then((r)=>r.text());
        container.innerHTML = content;
    };
    return me;
})();
var $3a934ee67fa09fba$export$2e2bcd8739ae039 = $3a934ee67fa09fba$var$Information;






let $a6123031a25dee56$var$TranslationEditor = (()=>{
    let me = {};
    let translations = {};
    let listContainer;
    let button;
    async function loadTranslations() {
        let languages = [
            "en",
            "fr"
        ];
        let promises = languages.map((lang)=>{
            let path = "_data/translations/" + lang + ".json?v=" + Date.now();
            return fetch(path).then((res)=>res.json());
        });
        let results = await Promise.all(promises);
        results.forEach((res, i)=>{
            translations[languages[i]] = res;
        });
    }
    function updateTranslation() {
        let inputs = listContainer.querySelectorAll("input.lang");
        inputs.forEach((input)=>{
            let id = input.id.split(":");
            let lang = id[0];
            let key = id[1];
            if (!translations[lang]) {
                console.error("No translations for language", lang, key, input.value);
                console.error(input);
                translations[lang] = {};
            }
            translations[lang][key] = input.value;
        });
        console.log(translations);
        (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).waiting(true);
        if (button) {
            button.classList.add("loading");
            button.disabled = true;
        }
        (0, $1405dab32d7e0174$export$2e2bcd8739ae039).update("translations", translations).then((result)=>{
            console.log(result);
        }).catch((error)=>{
            console.error(error);
        }).finally(()=>{
            (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).waiting(false);
            if (button) {
                button.classList.remove("loading");
                button.disabled = false;
            }
        });
    }
    me.filter = (value)=>{
        if (!listContainer) return;
        let p = (value || "").toLowerCase();
        Array.from(listContainer.children).forEach((row)=>{
            let key = row.querySelector(".key").innerText.toLowerCase();
            let match = key.indexOf(p) >= 0;
            if (!match) {
                let inputs = row.querySelectorAll("input");
                inputs.forEach((input)=>{
                    if (input.value.toLowerCase().indexOf(p) >= 0) match = true;
                });
            }
            row.style.display = match ? "" : "none";
        });
    };
    me.render = async (container)=>{
        container.innerHTML = "<center><br><div class='spinner'></div></center>";
        await loadTranslations();
        let editor = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".translationeditor", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".list", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".header", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label.cell", "Key"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label.cell.wide", "English"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label.cell.wide", "French")), listContainer = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".itemlist"), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".buttons", {
            onClick: updateTranslation
        }, button = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button.primary.green", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), "Update"))));
        let keys = Object.keys(translations.en);
        Object.keys(translations.fr).forEach((key)=>{
            if (!keys.includes(key)) keys.push(key);
        });
        keys.sort();
        keys.forEach((key)=>{
            let item = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".row", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".key.cell", key), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".cell.wide", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input.lang", {
                type: "text",
                value: translations.en[key] || "",
                "id": "en:" + key
            })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".cell.wide", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input.lang", {
                type: "text",
                value: translations.fr[key] || "",
                "id": "fr:" + key
            })));
            listContainer.append(item);
        });
        container.innerHTML = "";
        container.append(editor);
    };
    return me;
})();
var $a6123031a25dee56$export$2e2bcd8739ae039 = $a6123031a25dee56$var$TranslationEditor;




let $bff3fb64f27a9389$var$Page = (()=>{
    let me = {};
    let pageContainer = null;
    let titleBar = null;
    let spinner = null;
    let colors = {
        orange: "#b78938",
        green: "#8cce71",
        blue: "#51869d",
        grey: "#888888"
    };
    if ((0, $7cd192843b2495ee$export$2e2bcd8739ae039).getTheme() === "light") colors = {
        orange: "#f5aa43",
        green: "#8ef663",
        blue: "#1dc3ff",
        grey: "#cccccc"
    };
    let pages = {
        "home": {
            title: "home",
            render: (0, $0a8366f18a86398d$export$2e2bcd8739ae039).render
        },
        "utilisateurs": {
            title: "Utilisateurs",
            render: (0, $c1efb87e31920064$export$2e2bcd8739ae039).render
        },
        "incidents-sms": {
            title: "Incidents SMS",
            render: (0, $f80621448b29dfb8$export$2e2bcd8739ae039).render
        },
        "incidents-sms/non-assignes": {
            title: "Incidents SMS - Non Assign\xe9s",
            render: (0, $f80621448b29dfb8$export$2e2bcd8739ae039).render,
            params: {
                filter: "nonassigned"
            },
            color: colors.orange
        },
        "incidents-sms/assignes": {
            title: "Incidents SMS - Assign\xe9s",
            render: (0, $f80621448b29dfb8$export$2e2bcd8739ae039).render,
            params: {
                filter: "assigned"
            },
            color: colors.green
        },
        "incidents-sms/archives": {
            title: "Incidents SMS - Archiv\xe9s",
            render: (0, $f80621448b29dfb8$export$2e2bcd8739ae039).render,
            params: {
                filter: "archived"
            },
            color: colors.blue
        },
        "organisations": {
            title: "Organisations",
            render: (0, $605b2b6cbe61d8c6$export$2e2bcd8739ae039).render
        },
        "information": {
            title: "information",
            render: (0, $3a934ee67fa09fba$export$2e2bcd8739ae039).render
        },
        "translations": {
            title: "Translations",
            render: (0, $a6123031a25dee56$export$2e2bcd8739ae039).render,
            onSearch: (0, $a6123031a25dee56$export$2e2bcd8739ae039).filter
        },
        "incidents-cso": {
            title: "Incidents CSO",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render
        },
        "mes-incidents/nouveaux": {
            title: "Mes Incidents - Nouveaux",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "new"
            },
            color: colors.orange
        },
        "mes-incidents/ouvert": {
            title: "Mes Incidents - Ouverts",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "working"
            },
            color: colors.green
        },
        "mes-incidents/completes": {
            title: "Mes Incidents - Compl\xe9t\xe9s",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "complete"
            },
            color: colors.blue
        },
        "mes-incidents/archives": {
            title: "Mes Incidents - Archiv\xe9s",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "myarchived"
            },
            color: colors.grey
        },
        "incidents-cso/nouveaux": {
            title: "Tous les Incidents CSO - Nouveaux",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "pending"
            },
            color: colors.orange
        },
        "incidents-cso/ouvert": {
            title: "Tous les Incidents CSO - Ouverts",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "open"
            },
            color: colors.green
        },
        "incidents-cso/completes": {
            title: "Tous les Incidents CSO - Compl\xe9t\xe9s",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "closed"
            },
            color: colors.blue
        },
        "incidents-cso/archives": {
            title: "Tous les Incidents CSO - Archiv\xe9s",
            render: (0, $9b28866441da4ff1$export$2e2bcd8739ae039).render,
            params: {
                filter: "allarchived"
            },
            color: colors.grey
        }
    };
    me.load = (pageName, container)=>{
        console.log("Loading page " + pageName);
        let id;
        if (pageName.indexOf("/") > 0) {
            let parts = pageName.split("/");
            let p = parts.pop();
            if (isNaN(p)) {
                if ((0, $4ef65c8b9751a142$export$a1a1baf9c6597488)(p)) {
                    id = p;
                    pageName = parts.join("/");
                } else id = undefined;
            } else {
                id = p;
                pageName = parts.join("/");
            }
        }
        if (!container) container = document.body.querySelector("main");
        if (!pageContainer) pageContainer = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("div.page", {
            parent: container
        });
        pageContainer.innerHTML = "";
        let page = pages[pageName];
        if (page) {
            //history.pushState({page:pageName},page.title,pageName);
            window.location.hash = pageName;
            let title = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)[page.title] || page.title || pageName;
            document.title = "Kufatilia - " + title;
            titleBar = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".titlebar", {
                parent: pageContainer
            }, spinner = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("span"), page.color ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".dot", {
                style: {
                    backgroundColor: page.color
                }
            }) : null, title);
            let pageContent = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".pagecontent", {
                parent: pageContainer
            });
            if (page.render) page.render(pageContent, page.params, id);
            if (page.onSearch) {
                let searchInput;
                (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".topsearch", {
                    parent: titleBar
                }, searchInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                    type: "text",
                    placeholder: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039)["Search..."] || "Search...",
                    oninput: ()=>{
                        page.onSearch(searchInput.value);
                    }
                }));
            }
            (0, $11c795e9343571a1$export$2e2bcd8739ae039).sync(pageName);
        }
    };
    me.waiting = (state)=>{
        if (titleBar) titleBar.classList.toggle("loading", state);
        if (state) {
            if (spinner) spinner.innerHTML = "<div class='spinner'></div>";
        } else if (spinner) spinner.innerHTML = "";
    };
    return me;
})();
var $bff3fb64f27a9389$export$2e2bcd8739ae039 = $bff3fb64f27a9389$var$Page;







let $11c795e9343571a1$var$Nav = (()=>{
    let me = {};
    let menu;
    let itemMap = {};
    me.render = async (container)=>{
        let colors = {
            orange: "#b78938",
            green: "#8cce71",
            blue: "#51869d",
            grey: "#888888"
        };
        if ((0, $7cd192843b2495ee$export$2e2bcd8739ae039).getTheme() === "light") colors = {
            orange: "#f5aa43",
            green: "#76ce52",
            blue: "#0aa7dc",
            grey: "#cccccc"
        };
        menu = [
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).incidentsSMS,
                items: [
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).nonAssigned,
                        page: "incidents-sms/non-assignes",
                        key: "nonassigned",
                        color: colors.orange
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).assignedPlural,
                        page: "incidents-sms/assignes",
                        key: "assigned",
                        color: colors.green
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archivedPlural,
                        page: "incidents-sms/archives",
                        key: "archived",
                        color: colors.blue
                    }
                ],
                scope: "admin"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).myIncidents,
                items: [
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).newPlural,
                        page: "mes-incidents/nouveaux",
                        key: "new",
                        color: colors.orange
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).open,
                        page: "mes-incidents/ouvert",
                        key: "working",
                        color: colors.green
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).completed,
                        page: "mes-incidents/completes",
                        key: "complete",
                        color: colors.blue
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived,
                        page: "mes-incidents/archives",
                        key: "myarchived",
                        color: colors.grey,
                        scope: "admin"
                    }
                ]
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).allIncidentsCSO,
                items: [
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).newPlural,
                        page: "incidents-cso/nouveaux",
                        key: "pending",
                        color: colors.orange
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).open,
                        page: "incidents-cso/ouvert",
                        key: "open",
                        color: colors.green
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).completed,
                        page: "incidents-cso/completes",
                        key: "closed",
                        color: colors.blue
                    },
                    {
                        label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).archived,
                        page: "incidents-cso/archives",
                        key: "allarchived",
                        color: colors.grey,
                        scope: "admin"
                    }
                ]
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).users,
                page: "utilisateurs",
                scope: "owner"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).organisations,
                page: "organisations",
                scope: "owner"
            },
            {
                label: (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).translations,
                page: "translations",
                scope: "owner"
            },
            {
                label: "Information",
                page: "information"
            }
        ];
        let menuElm;
        (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("nav", {
            parent: container
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".titlebar", {
            onClick: ()=>{
                (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("home");
            }
        }, "Kufatilia"), menuElm = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menu"));
        menu.forEach((item)=>{
            if (item.scope === "admin" && !(0, $dad842a3fb977628$export$2e2bcd8739ae039).isAdmin()) return;
            if (item.scope === "owner" && !(0, $dad842a3fb977628$export$2e2bcd8739ae039).isOwner()) return;
            let menuitem = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menuitem", {
                parent: menuElm,
                onClick: (e)=>{
                    let openItems = menuElm.querySelectorAll(".menuitem.open");
                    openItems.forEach((item)=>{
                        if (item === menuitem) return;
                        item.classList.remove("open");
                    });
                    let triggerLoad = true;
                    if (item.items) {
                        if (menuitem.classList.contains("open")) triggerLoad = false;
                        menuitem.classList.toggle("open");
                    }
                    if (triggerLoad) {
                        if (item.page) (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load(item.page);
                        if (item.action) item.action(e);
                    }
                }
            }, item.label, item.key ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".badge") : null);
            item.element = menuitem;
            if (item.items) {
                let submenu = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".submenu", {
                    parent: menuitem
                });
                item.items.forEach((subitem)=>{
                    if (subitem.scope === "admin" && !(0, $dad842a3fb977628$export$2e2bcd8739ae039).isAdmin()) return;
                    if (subitem.type === "title") {
                        subitem.element = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menutitle", {
                            parent: submenu
                        }, subitem.label);
                        return;
                    }
                    subitem.element = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".menuitem", {
                        parent: submenu,
                        onClick: ()=>{
                            (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load(subitem.page);
                        }
                    }, subitem.label, subitem.key ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".badge") : null, subitem.color ? (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".dot", {
                        style: {
                            backgroundColor: subitem.color
                        }
                    }) : null);
                    if (subitem.key) itemMap[subitem.key] = subitem.element;
                });
            }
        });
    };
    me.sync = (pageName)=>{
        if (!menu) return;
        let item = menu.find((item)=>item.page == pageName);
        if (item) {
            let openItems = document.body.querySelectorAll(".menuitem.open");
            openItems.forEach((item)=>{
                item.classList.remove("open");
            });
            if (item.element) item.element.classList.add("open");
        } else {
            let parentItem = null;
            menu.forEach((item)=>{
                if (item.items) item.items.forEach((subitem)=>{
                    if (subitem.element) subitem.element.classList.remove("active");
                    if (subitem.page === pageName) {
                        parentItem = item;
                        if (subitem.element) subitem.element.classList.add("active");
                    }
                });
            });
            if (parentItem) {
                let openItems = document.body.querySelectorAll(".menuitem.open");
                openItems.forEach((item)=>{
                    item.classList.remove("open");
                });
                if (parentItem.element) parentItem.element.classList.add("open");
            }
        }
    };
    me.updateStats = async (forceRefresh)=>{
        let userData = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getCurrentUser();
        let orgId = userData ? userData.organisation : "";
        let stats = await (0, $1405dab32d7e0174$export$2e2bcd8739ae039).getStats(orgId, forceRefresh);
        if (!menu) return;
        function setBadge(elm, count) {
            if (elm) {
                elm.innerHTML = count;
                if (count > 0) elm.classList.add("active");
                else elm.classList.remove("active");
            }
        }
        menu.forEach((item)=>{
            if (item.key) {
                let value = stats[item.key];
                if (typeof value === "number") setBadge(item.element.querySelector(".badge"), value);
            }
            if (item.items) item.items.forEach((subitem)=>{
                if (subitem.key) {
                    let value = stats[subitem.key];
                    if (typeof value === "number" && subitem.element) setBadge(subitem.element.querySelector(".badge"), value);
                }
            });
        });
    };
    me.animateUpdate = (from, to, content)=>{
        let fromElm = itemMap[from];
        let toElm = itemMap[to];
        if (fromElm && toElm && isVisible(fromElm) && isVisible(toElm)) {
            let fromRect = fromElm.getBoundingClientRect();
            let toRect = toElm.getBoundingClientRect();
            let dot = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".movedot", {
                style: {
                    top: fromRect.top + "px",
                    left: fromRect.width + "px"
                }
            }, content);
            setTimeout(()=>{
                dot.classList.add("active");
                dot.classList.add("move");
                let targetY = fromRect.top + Math.round((toRect.top - fromRect.top) / 2);
                dot.style.top = targetY + "px";
            }, 20);
            setTimeout(()=>{
                dot.style.top = toRect.top + "px";
                dot.classList.remove("move");
            }, 500);
            setTimeout(()=>{
                dot.classList.remove("active");
            }, 700);
            setTimeout(()=>{
                document.body.removeChild(dot);
            }, 1200);
            document.body.appendChild(dot);
        }
    };
    function isVisible(elm) {
        let parent = elm.closest(".submenu");
        if (parent) parent = parent.closest(".menuitem");
        if (!parent) return true;
        return parent.classList.contains("open");
    }
    (0, $9a3384fd4b0dd5ab$export$2e2bcd8739ae039).on("dataChanged", me.updateStats);
    window.u = async function() {
        me.animateUpdate("nonassigned", "assigned", 1);
    };
    return me;
})();
var $11c795e9343571a1$export$2e2bcd8739ae039 = $11c795e9343571a1$var$Nav;








let $a655869767c8fbe0$var$Login = (()=>{
    let me = {};
    me.render = (container)=>{
        return new Promise((next)=>{
            container.innerHTML = "";
            document.body.classList.add("login");
            let panel, loginInput, passwordInput, button, title;
            container.appendChild(panel = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".login", title = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".title", "Kufatilia v" + (0, $7cd192843b2495ee$export$2e2bcd8739ae039).version), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inputbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).username), loginInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                "type": "text",
                onkeyup: (e)=>{
                    if (e.keyCode === 13) button.onClick();
                }
            })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inputbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).password), passwordInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
                "type": "password",
                onkeyup: (e)=>{
                    if (e.keyCode === 13) button.onClick();
                }
            })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".textlink", {
                onClick: (e)=>{
                    e.stopPropagation();
                    renderPasswordResetForm(container, next);
                }
            }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).forgotPassword), button = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button", {
                onClick: ()=>{
                    let login = validate(loginInput);
                    let password = validate(passwordInput);
                    if (login && password) {
                        button.classList.add("loading");
                        (0, $dad842a3fb977628$export$2e2bcd8739ae039).login(login, password).then((result)=>{
                            button.classList.remove("loading");
                            if (!result.success) {
                                title.innerHTML = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).loginFailed;
                                shake(panel);
                            } else if (result.needsPasswordReset) renderPasswordReset(container, next);
                            else {
                                let userData = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getCurrentUser();
                                if (userData && userData.id && !userData.active) {
                                    title.innerHTML = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).accountIsDisabled;
                                    shake(panel);
                                    return;
                                }
                                container.innerHTML = "";
                                document.body.classList.remove("login");
                                next();
                            }
                        }).catch(()=>{
                            button.classList.remove("loading");
                        });
                    }
                }
            }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).login)));
        });
    };
    function renderPasswordReset(container, next) {
        container.innerHTML = "";
        document.body.classList.add("passwordreset");
        let currentUser = (0, $dad842a3fb977628$export$2e2bcd8739ae039).getCurrentUser();
        let pass1, pass2, title;
        container.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".login", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("h2", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).hello + " " + currentUser.fullname), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".intro", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).firstLogin), title = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".intro", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).pleaseChangePassword), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inputbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).newPassword), pass1 = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
            "type": "password"
        })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inputbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).confirmPassword), pass2 = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input", {
            "type": "password"
        })), (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button", {
            onClick: ()=>{
                let p1 = validate(pass1);
                let p2 = validate(pass2);
                if (p1 !== p2) {
                    title.innerHTML = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).passwordsDontMatch;
                    validate(pass1, true);
                    validate(pass2, true);
                }
                if (p1 && p2 && p1 === p2) (0, $1405dab32d7e0174$export$2e2bcd8739ae039).changePassword(p1).then(()=>{
                    container.innerHTML = "";
                    document.body.classList.remove("passwordreset");
                    document.body.classList.remove("login");
                    next();
                });
            }
        }, (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).changePassword)));
    }
    function renderPasswordResetForm(container, next) {
        let title, inputBox, emailInput, button;
        container.innerHTML = "";
        container.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".login", title = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".title", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).enterEmail), inputBox = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".inputbox", (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("label", (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).username), emailInput = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("input")), button = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("button", {
            onClick: ()=>{
                let login = validate(emailInput);
                if (login && (!login.includes("@") || !login.includes("."))) {
                    validate(emailInput, true);
                    login = null;
                }
                if (login) {
                    button.classList.add("loading");
                    (0, $1405dab32d7e0174$export$2e2bcd8739ae039).resetPassword(login).then((result)=>{
                        button.style.display = "none";
                        inputBox.style.display = "none";
                        title.innerHTML = (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).enterEmailThankYou;
                    });
                }
            }
        }, (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".spinner"), (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).continue)));
    }
    function validate(input, iserror) {
        let value = input.value;
        if (!value || iserror) {
            let parent = input.closest(".inputbox");
            parent.classList.remove("error");
            setTimeout(()=>{
                parent.classList.add("error");
            }, 10);
        }
        return value;
    }
    function shake(elm) {
        elm.classList.remove("shake");
        setTimeout(()=>{
            elm.classList.add("shake");
        }, 10);
    }
    return me;
})();
var $a655869767c8fbe0$export$2e2bcd8739ae039 = $a655869767c8fbe0$var$Login;








let $bd6b4fc86ce39e36$var$container;
async function $bd6b4fc86ce39e36$var$setupUI() {
    (0, $457b660dfd8a7276$export$2e2bcd8739ae039).init();
    let currentLang = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
    await (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).load(currentLang);
    (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).init();
    $bd6b4fc86ce39e36$var$container = (0, $ab86e7844b98ec72$export$2e2bcd8739ae039)("main");
    document.body.appendChild($bd6b4fc86ce39e36$var$container);
    let isLoggedIn = await (0, $dad842a3fb977628$export$2e2bcd8739ae039).isLoggedIn();
    if (isLoggedIn) {
        let newLang = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
        if (currentLang !== newLang) {
            await (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).load(newLang);
            (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).init();
        }
        let theme = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getTheme();
        if (theme === "light") document.body.classList.add("light");
        $bd6b4fc86ce39e36$var$home();
    } else {
        let theme = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getTheme();
        if (theme === "light") document.body.classList.add("light");
        (0, $a655869767c8fbe0$export$2e2bcd8739ae039).render($bd6b4fc86ce39e36$var$container).then(()=>{
            (0, $dad842a3fb977628$export$2e2bcd8739ae039).isLoggedIn().then(async (isLoggedIn)=>{
                if (isLoggedIn) {
                    let newLang = (0, $7cd192843b2495ee$export$2e2bcd8739ae039).getLanguage();
                    if (currentLang !== newLang) {
                        await (0, $a326efb1bdfc44d1$export$2e2bcd8739ae039).load(newLang);
                        (0, $27ed2bfcca54492f$export$2e2bcd8739ae039).init();
                    }
                    $bd6b4fc86ce39e36$var$home();
                } else window.location.reload();
            });
        });
    }
    if ((0, $1405dab32d7e0174$export$2e2bcd8739ae039).isDev()) document.body.appendChild((0, $ab86e7844b98ec72$export$2e2bcd8739ae039)(".devmode", "DEVELOPMENT ENVIRONMENT"));
}
function $bd6b4fc86ce39e36$var$home() {
    (0, $11c795e9343571a1$export$2e2bcd8739ae039).render($bd6b4fc86ce39e36$var$container);
    (0, $11c795e9343571a1$export$2e2bcd8739ae039).updateStats(true);
    (0, $dad842a3fb977628$export$2e2bcd8739ae039).renderUserMenu($bd6b4fc86ce39e36$var$container);
    let hash = window.location.hash;
    if (hash) {
        hash = hash.substr(1);
        (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load(hash, $bd6b4fc86ce39e36$var$container);
    } else (0, $bff3fb64f27a9389$export$2e2bcd8739ae039).load("home", $bd6b4fc86ce39e36$var$container);
}
document.addEventListener("DOMContentLoaded", function(event) {
    $bd6b4fc86ce39e36$var$setupUI();
});


//# sourceMappingURL=index.12e24f31.js.map
